export default {
  generationFailureDialog: {
    title: "生成失败",
    message: "AI 服务暂时不可用，请稍后重试。",
    fallbackDetail: "这可能是因为网络波动或服务器繁忙。",
    refundText: "积分已退回",
    retryText: "重新生成",
    backText: "返回",
  },
  dashboard: {
    title: "工作台",
    welcome: "欢迎回来，{name} · {date}",
    creator: "创作者",
    metricsLabel: "工作台数据概览",
    pointsBalance: "积分消耗（近7日）",
    workflowTotal: "漫剧工作流-视频时长（近7日）",
    canvasTotal: "画布-视频时长（近7日）",
    scriptTotal: "剧本集数（近7日）",
    pointsUnit: "积分",
    secondsUnit: "秒",
    episodesUnit: "集",
    changeRate: "环比 {value}%",
    noChange: "环比 --",
    recentWorkflow: "最近漫剧工作流项目",
    recentCanvas: "最近画布项目",
    recentScripts: "最近剧本",
    workflowProjects: "漫剧项目",
    canvasProjects: "画布项目",
    trendTitle: "近 30 天积分消耗趋势",
    trendAria: "近 30 天漫剧项目与画布项目创建趋势图",
    viewAll: "全部",
    view: "查看",
    download: "下载",
    downloadFailed: "剧本下载失败，请稍后重试",
    emptyProjects: "暂无项目",
    emptyScripts: "暂无剧本",
    untitled: "未命名",
    script: "剧本",
    episodes: "{count} 集",
    styleUnset: "未设置风格",
    recently: "最近更新",
    today: "今天",
    yesterday: "昨天",
    daysAgo: "{count} 天前",
  },
  common: {
    language: "语言",
    loading: "加载中...",
    uploading: "上传中...",
    search: "搜索",
    cancel: "取消",
    confirm: "确定",
    tip: "提示",
    saveChanges: "保存修改",
    save: "保存",
    edit: "编辑",
    delete: "删除",
    select: "请选择",
    clickSelect: "点击选择",
    selectAll: "全选",
    batchGenerate: "批量生成",
    generating: "生成中",
  },
  confirmDialog: {
    logout: {
      title: "退出登录？",
      message: "退出登录不会丢失任何数据，你仍可以随时登录本账号。",
      confirm: "退出登录",
    },
  },
  teamManagementPage: {
    title: "团队管理",
    currentTeam: "当前团队共",
    people: "人",
    seats: "席位",
    createAccount: "创建账户",
    inviteMember: "邀请成员",
    invite: {
      title: "生成邀请链接",
      generatedTitle: "邀请链接已生成",
      close: "关闭邀请成员弹窗",
      link: "邀请链接",
      generateLink: "生成邀请链接",
      copyLink: "一键复制",
      resultTip: "将链接发送给成员，对方完成注册后即可加入团队。",
      copySuccess: "邀请链接已复制",
      copyFailed: "邀请链接复制失败",
      generateFailed: "邀请链接生成失败",
    },
    subscriptionTip: "订阅积分每月对月日 23:59:59 到期清零，不跨月累积",
    searchPlaceholder: "搜索成员昵称或手机号...",
    cards: {
      totalPoints: "可分配总积分",
      rechargePoints: "可分配充值积分",
      subscriptionPoints: "可分配订阅积分",
      totalConsumed: "总积分消耗",
      rechargeConsumed: "普通积分消耗",
      subscriptionConsumed: "订阅积分消耗",
    },
    columns: {
      nickname: "昵称",
      accountLevel: "账号层级",
      role: "角色",
      parentAdmin: "所属管理员",
      phone: "手机号",
      rechargeRemaining: "充值剩余",
      rechargeUsed: "充值已用",
      subscriptionRemaining: "订阅剩余",
      subscriptionUsed: "订阅已用",
      status: "账号状态",
      createdAt: "创建时间",
      lastLogin: "最后登录",
      actions: "操作",
    },
    disabled: "禁用",
    enabled: "启用",
    allocatePoints: "分配积分",
    resetPassword: "重置密码",
    remove: "移除",
    totalPeople: "共 {count} 人",
    editMember: "编辑成员",
    badges: {
      defaultAdmin: "默认管理员",
      defaultAdminTip: "默认管理员不可登录，超级管理员持有管理权限",
    },
    accountTypes: {
      superAdmin: "超级管理员",
      levelOneAdmin: "管理员",
      levelTwoAdmin: "子管理员",
      admin: "管理员",
      member: "成员",
    },
    form: {
      nickname: "昵称",
      nicknamePlaceholder: "成员昵称",
      username: "用户名",
      usernamePlaceholder: "请输入用户名",
      accountType: "账号类型",
      accountTypePlaceholder: "请选择账号类型",
      role: "业务角色",
      rolePlaceholder: "请选择业务角色",
      parentAdmin: "所属管理员",
      parentAdminPlaceholder: "请选择所属管理员",
      phone: "手机号",
      phonePlaceholder: "11 位手机号",
      password: "设置密码",
      confirmPassword: "确认密码",
    },
    roleHelp: {
      ariaLabel: "查看角色权限说明",
      producer: {
        title: "制片",
        optionDescription: "最高权限，可新建和分配项目",
        description:
          "团队最高权限。可新建项目、分配项目与资产，管理项目内全部内容。",
        scope: "可查看自己创建的和被分配的项目。",
      },
      director: {
        title: "导演",
        optionDescription: "不能新建项目，被分配后参与协作",
        description:
          "不能新建项目，需被分配后进入项目协作，可编辑项目内的剧本、分镜与资产。",
        scope: "仅能查看被分配给你的项目。",
      },
      operator: {
        title: "操作员",
        optionDescription: "不能新建项目，权限由管理员分配",
        description:
          "不能新建项目，需被分配后进入项目协作，具体可操作范围由管理员分配的权限决定。",
        scope: "仅能查看被分配给你的项目。",
      },
      adminNote:
        "数据范围按账号层级裁剪：超级管理员看本企业全部；一级看自己分支；二级看本人及直属成员。显式授权只对被授权人有效。无限画布项目不受此限制，各角色均可自行创建。",
    },
    unbound: "未绑定",
    verified: "已验证",
    initialPoints: "初始积分分配（选填）",
    rechargePoints: "充值积分",
    subscriptionPoints: "订阅积分",
    pointsUnit: "积分",
    rechargePoolRemaining: "本人可分配直充积分",
    subscriptionPoolRemaining: "本人可分配订阅积分",
    pointsReadonly: "积分信息（只读）",
    removeMember: "移除成员",
    pointsDialog: {
      pointType: "积分类型",
      poolOption: "{type}（本人剩余：{points}）",
      addPoints: "增加积分",
      addDescription: "从本人账户划拨给该账号（本人剩余 {points}）",
      reclaimPoints: "收回积分",
      reclaimDescription: "从该账号收回至本人账户（对方剩余 {points}）",
      amountPlaceholder: "请输入积分数量",
      confirmAllocate: "确认分配",
      add: "增加",
      reclaim: "收回",
      amountLabel: "{action}{type}数额",
      teamPoolRemaining: "本人{type}剩余 ",
      memberRemaining: "该账号{type}当前剩余 ",
    },
    validation: {
      phoneRequired: "请输入手机号",
      phoneInvalid: "请输入有效的手机号",
      phoneLength: "请输入11位手机号",
      pointsRequired: "请输入积分数量",
      pointsExceeded: "超出可分配额度",
      roleRequired: "请选择业务角色",
      accountTypeRequired: "请选择账号类型",
      parentAdminRequired: "请选择所属管理员",
      nicknameRequired: "请输入昵称",
      pointTypeRequired: "请选择积分类型",
      operationRequired: "请选择操作",
      passwordRequired: "密码不能为空",
      passwordMin: "密码至少 6 位",
      confirmPasswordRequired: "请再次输入密码",
      passwordMismatch: "两次输入的密码不一致",
      usernameRequired: "请输入用户名",
    },
    time: {
      justNow: "刚刚",
      minutesAgo: "{n} 分钟前",
      hoursAgo: "{n} 小时前",
      daysAgo: "{n} 天前",
    },
    memberFallback: "员",
    roles: {
      owner: "所有者",
      producer: "制片",
      director: "导演",
      operator: "操作员",
    },
    messages: {
      success: "操作成功",
      failed: "操作失败",
      statusUpdated: "账号状态更新成功",
      statusUpdateFailed: "账号状态更新失败",
      overviewFailed: "获取团队总览失败",
      membersFailed: "获取成员列表失败",
      removeSuccess: "移除成功",
      removeFailed: "移除失败",
      resetPasswordFailed: "重置密码失败",
      hasChildren: "该账号仍有直属下级，请先调整下级归属后再删除",
    },
    removeConfirm: {
      title: "确定要移除「{name}」吗？",
      message:
        "移除后该账号将被删除，剩余直充积分和订阅积分将转入直属上级。若仍有直属下级，将无法删除。",
      confirm: "确定移除",
    },
    statusConfirm: {
      enableTitle: "确定要启用「{name}」吗？",
      enableMessage: "启用后，该账号将恢复登录与使用，是否确认启用？",
      enableConfirm: "确定启用",
      disableTitle: "确定要禁用「{name}」吗？",
      disableMessage: "禁用后，该账号将无法登录与使用，是否确认禁用？",
      disableConfirm: "确定禁用",
    },
    resetPasswordConfirm: {
      title: "确定要重置「{name}」的密码吗？",
      message: "重置后将生成新密码，原密码立即失效，是否确认重置？",
      confirm: "确定重置",
    },
    resetPasswordResult: {
      title: "重置密码",
      target: "重置对象",
      newPassword: "重置后密码",
      tip: "请及时告知用户使用新密码登录，并提醒登录后尽快修改密码。",
      close: "关闭",
      copy: "复制",
      copySuccess: "密码已复制",
      copyFailed: "复制失败",
    },
  },
  app: {
    title: "漫枢-AI漫短剧创作管理平台",
    firstLogin: {
      title: "积分分配说明",
      welcome: "欢迎企业版用户登录。",
      gift: "已赠送积分到超级管理员账户，请先到“团队管理”页面{action}。",
      action: "分配后使用",
      followUp:
        "后续充值购买的积分会进入对应账号；管理员需从本人账户向团队成员分配后再使用。",
      allocate: "去分配",
      dismiss: "我知道了，暂不分配",
    },
  },
  activityBanner: {
    ariaLabel: "限时会员活动",
    remaining: "活动剩余",
    days: "天",
    hours: "时",
    minutes: "分",
    seconds: "秒",
    longTerm: "长期有效",
    title: "Seedance 2.5 720P 年会员限时优惠",
    description: "生成低至 0.39 元/秒，年会员最低 4.5 折",
    action: "限时抢购",
    close: "关闭活动横幅",
  },
  header: {
    logoAlt: "AI漫剧创作平台",
    taskCenter: {
      title: "任务中心",
      open: "打开任务中心",
      close: "关闭任务中心",
      typeLabel: "任务类型",
      taskTitle: "{type}生成任务 #{index}",
      points: "-{points}积分",
      sourceDescription: "定位到漫剧/画布/剧本-项目名-集数名-分镜...",
      failureReason: "失败原因",
      timeoutReason: "生成服务响应超时",
      reportError: "一键反馈",
      report: {
        title: "提交任务错误",
        subtitle: "{task} · 消耗 {points} 积分",
        close: "关闭提交任务错误弹窗",
        summary: "错误摘要（只读）",
        description: "一句话描述你遇到的问题",
        placeholder: "例如：角色生成到 80% 后停止，没有返回结果",
        descriptionRequired: "请输入问题描述",
        cancel: "取消",
        submit: "提交错误",
      },
      tasks: {
        scriptAnalysis: "脚本分析",
        characterAsset: "角色资产生成",
        sceneAsset: "场景资产生成",
        styleTransfer: "风格迁移",
        coverImage: "封面图生成",
        storyboard: "分镜生成",
      },
      scrollForMore: "下拉加载更多",
      allLoaded: "已加载全部",
      empty: "暂无任务",
      loadFailed: "任务加载失败，请稍后重试",
      status: { all: "全部", running: "进行中", success: "已完成", failed: "失败" },
      type: { image: "图片任务", video: "视频任务" },
      description: {
        running: "生成中 · {time}",
        success: "生成完成 · {time}",
        failed: "生成失败 · {time}",
      },
    },
    nav: {
      home: "首页",
      workflow: "漫剧工作流",
      canvas: "泫宗画布",
      scriptCreation: "剧本创作",
      dataInsights: "数据洞察",
      efficiencyAnalysis: "人效分析",
      help: "使用帮助",
      guide: "操作指南",
      productUpdates: "产品动态",
    },
    language: {
      label: "切换语言",
      zhCN: "简体中文",
      enUS: "English",
      yueHK: "粤中",
      shortZhCN: "中文",
      shortEnUS: "EN",
      shortYueHK: "粤中",
    },
    accountMenu: {
      currentAccount: "当前账户",
      personalCenter: "个人中心",
      changePassword: "修改密码",
      teamManagement: "团队管理",
      invoice: "订单管理",
      rechargeRecords: "充值记录",
      filingInfo: "备案信息",
      feedback: "问题反馈",
      contactUs: "联系我们",
      changelog: "更新日志",
      language: "语言",
      logout: "退出登录",
    },
    passwordDialog: {
      title: "重置密码",
      oldPassword: "原密码",
      newPassword: "新密码",
      confirmNewPassword: "确认新密码",
      enterOldPassword: "请输入原密码",
      enterNewPassword: "请输入新密码",
      enterConfirmPassword: "请再次输入密码",
      passwordMismatch: "两次输入密码不一致！",
      success: "密码修改成功",
    },
    contactDialog: {
      title: "联系客服",
      description:
        "如有任何使用问题、充值订阅咨询或意见建议，欢迎扫码添加客服微信，我们将尽快为您解答。",
      qrCodeAlt: "客服微信二维码",
    },
    feedbackDialog: {
      bugHint: "功能异常、生成失败、页面报错、结果不符合当前设定。",
      optimizationHint: "已有功能能用，但体验、效率、展示或流程还可以变得更顺手。",
      featureHint: "当前还没有的能力，希望平台新增或扩展支持。",
      improvementLabel: "希望优化方式",
      improvementPlaceholder: "请说明你希望减少哪些步骤，或希望界面 / 流程如何调整",
      impactLabel: "使用频率 / 影响场景",
      impactPlaceholder: "例如：每天导出前都会使用，多人协作时影响更明显",
      scenarioLabel: "使用场景",
      scenarioPlaceholder: "请说明在什么业务场景下需要这个能力",
      goalLabel: "需求目标",
      goalPlaceholder: "请说明希望新增什么功能，最终要达成什么效果",
      valueLabel: "需求价值",
      valuePlaceholder: "例如：提升产能、减少人工返工、支持新的交付流程",
      title: "问题反馈",
      placeholder: "问题反馈",
      workspace: "工作台",
      close: "关闭",
      submitTitle: "提交问题反馈",
      submitDesc: "BUG、优化、新需求统一入口",
      submit: "提交反馈",
      saveDraft: "保存草稿",
      draftSaved: "草稿已保存",
      draftSaveFailed: "草稿保存失败，请稍后重试",
      draftEmpty: "请先填写至少一项内容再保存草稿",
      draftTitle: "{type}反馈：{title}",
      draftStatus: "草稿",
      continueEdit: "继续编辑",
      deleteDraft: "删除草稿",
      submitting: "提交中...",
      submitSuccess: "反馈已提交",
      submitFailed: "反馈提交失败，请稍后重试",
      uploadFailed: "附件上传失败，请重试",
      uploading: "上传中...",
      uploaded: "已上传",
      removeFile: "移除文件",
      fileCountInvalid: "最多上传 5 个附件",
      fileTypeInvalid: "仅支持 PNG、JPG、JPEG 或 MP4 文件",
      fileSizeInvalid: "文件大小必须大于 0 且不超过 200 MB",
      myFeedback: "我的反馈",
      empty: "暂无数据",
      listHint: "查看已提交问题反馈的回复、状态变更与通知。",
      view: "查看",
      platformReply: "平台回复",
      delete: "删除",
      formTitle: "反馈问题",
      formHint: "选择类型后填写必要信息，提交后进入后台工单。",
      typeLabel: "问题类型",
      typeBug: "BUG",
      typeOptimization: "优化",
      typeFeature: "新需求",
      titleLabel: "问题标题",
      titlePlaceholder: "一句话说明遇到的问题",
      requiredField: "请输入{field}",
      moduleLabel: "所属模块",
      moduleCanvas: "浓案画布",
      moduleWorkflow: "工作流",
      moduleAccount: "账户中心",
      descriptionLabel: "问题描述",
      descriptionPlaceholder: "请描述发生了什么、出现在哪个项目或作品中",
      stepsLabel: "复现步骤",
      stepsPlaceholder: "例如：进入项目 - 选择镜头 - 点击生成 - 页面报错或结果异常",
      upload: "上传截图 / 录屏",
      uploadHint: "支持 PNG、JPG、MP4，提交后台可在工单详情查看附件。",
      detailTitle: "反馈详情",
      readonly: "只读信息，不可修改",
      ticket: "工单号",
      notProvided: "未填写",
      deleteTitle: "删除工单",
      deleteMessage: "是否删除此条工单？",
      cancel: "取消",
      confirmDelete: "确认删除",
      deleteSuccess: "反馈已删除",
      deleteFailed: "删除反馈失败，请稍后重试",
      replyTitle: "平台回复",
      replyContent: "回复内容",
      attachments: "附件",
      attachmentCount: "{count} 个文件",
      download: "下载",
      gotIt: "我知道了",
      statusProcessing: "处理中",
      statusResolved: "已处理",
      justNow: "刚刚",
    },
    // 登录成功后未读公告弹窗
    announcementDialog: {
      badge: "更新通知",
      fallbackTitle: "系统更新",
      publishedAt: "发布时间 {time}",
      confirm: "我知道了",
      closeAria: "关闭更新通知",
    },
    // 更新日志全屏弹窗（分页查询全部公告）
    changelog: {
      title: "更新日志",
      close: "关闭",
      empty: "暂无更新记录",
      emptyTip: "有新版本发布时，更新内容会显示在这里",
      loading: "加载中...",
      loadFailed: "更新日志加载失败，请稍后重试",
      retry: "重试",
      fallbackTitle: "系统更新",
    },
    pointsPopover: {
      managePoints: "积分管理",
      currentPoints: "当前积分",
      teamTotalPoints: "可分配积分",
      allocatePoints: "分配积分",
      rechargePoints: "充值积分",
      subscriptionPoints: "订阅积分",
      buyMembership: "会员订阅",
      buyPoints: "积分充值",
      viewUsage: "查看使用情况",
    },
    memberCenter: {
      editProfile: "编辑个人信息",
      editProfileHint: "仅可修改姓名",
      closeEditor: "关闭个人信息编辑",
      name: "姓名",
      namePlaceholder: "请输入姓名",
      phone: "手机号码",
      accountLevel: "账号层级",
      role: "角色",
      parentAdmin: "所属管理员",
      monthlyPoints: "每月积分",
      monthlyPointsEnterpriseHint: "（超级管理员账户）",
      showPhone: "显示",
      hidePhone: "隐藏",
      readonlyHint: "以上账号权限信息不可修改",
      personalAccount: "个人账号",
      enterpriseMainAccount: "企业主账号",
      enterpriseSubAccount: "企业子账号",
      saveSuccess: "个人信息修改成功",
      addSeats: "新增席位",
      addSeatsHint:
        "新增席位功能用于给当前团队订阅增加可用成员名额，新增席位立即生效，并与原团队订阅保持相同到期时间。",
      addSeatsPointsNotice:
        "本月增席发放的积分可延后使用，未消耗部分将于 {date} 重置。",
      addSeatsPointsHelp:
        "举例说明\n\n" +
        "假设您的套餐每月发放 20,000 积分，8 月 10 日增席 1 个席位，\n系统立即补发 5,000 积分。\n\n" +
        "情况一：周期内没用完\n9 月 10 日刷新时，账户还剩 6,000 积分\n→ 新周期到账 20,000 + 5,000 = 25,000 积分\n→ 10 月 10 日刷新时，恢复为 20,000 积分，增席积分不再延期\n\n" +
        "情况二：周期内只剩一部分\n9 月 10 日刷新时，账户只剩 3,000 积分\n→ 可延期额度按剩余的 3,000 计算，新周期到账 23,000 积分\n\n" +
        "情况三：周期内已用完\n9 月 10 日刷新时，账户余额为 0\n→ 没有可延期的积分，新周期到账 20,000 积分",
      addSeatsPointsHelpAria: "查看增席积分延期示例",
      subscriptionPointsResetNote: "{date} 23:59:59 清零 · 优先消耗",
    },
    recharge: {
      bonusRate: "（含赠送 {rate}%）",
    },
    accountCenter: {
      productName: "AI视频创作",
      nav: {
        account: "账户",
        usage: "使用情况",
        rechargeRecords: "充值记录",
      },
      accountInfo: "账户信息",
      registeredAt: "注册时间",
      account: "账号",
      points: "积分",
      totalPoints: "积分",
      serialNumber: "序号",
      columns: {
        details: "详情",
        time: "时间",
        pointsChange: "积分变更",
        model: "模型",
        resolution: "分辨率",
        duration: "时长",
        orderNo: "订单号",
        orderAmount: "订单金额",
        orderPoints: "订单积分",
        bonusPoints: "获赠积分",
        paymentMethod: "支付方式",
        orderTime: "下单时间",
      },
    },
    messages: {
      comingSoon: "即将上线，敬请期待",
    },
  },
  landing: {
    navLabel: "首页导航",
    home: "首页",
    productServices: "产品服务",
    aboutUs: "关于我们",
    login: "登录",
    startCreating: "开始创作",
    authPanel: {
      browserUnsupported: "您的浏览器不支持 HTML5 video 标签。",
      closePanel: "关闭登录面板",
      heroTitleManshu: "漫枢，让好故事被看见",
      heroTitleManjing: "漫镜，让好故事被看见",
      heroPrompt: "一键生成角色、分镜与视频画面",
      slogan: "让每一个好故事，都能让世界看见",
      titles: {
        welcomeManshu: "欢迎来到漫枢",
        welcomeManjing: "欢迎来到漫镜",
        register: "注册账号",
        bindPhone: "绑定手机号",
        password: "找回密码",
      },
      tabs: {
        account: "账号密码登录",
        phone: "验证码登录",
      },
      accountTypes: {
        enterprise: "企业",
        personal: "个人",
      },
      placeholders: {
        username: "请输入用户名",
        password: "请输入密码",
        phone: "请输入手机号",
        code: "请输入验证码",
        companyName: "请输入企业名称",
        invitation: "请输入邀请码（选填）",
        newPassword: "请输入新密码",
        confirmPassword: "请再次输入新密码",
      },
      actions: {
        login: "登录",
        register: "注册",
        getCode: "获取验证码",
        retryAfter: "{seconds}s 后重试",
        showPassword: "显示",
        hidePassword: "隐藏",
        resetPassword: "确定重置",
        bindAndLogin: "绑定并登录",
      },
      links: {
        forgotPassword: "忘记密码？",
        noAccount: "还没有账号？",
        registerNow: "立即注册",
        hasAccount: "已有账号？",
        loginNow: "立即登录",
        backToLogin: "返回登录",
        backToLoginWithArrow: "←返回登录",
      },
      agreement: {
        prefix: "登录即代表同意",
        terms: "《用户协议》",
        and: "和",
        privacy: "《隐私政策》",
      },
      bindPhone: {
        tip: "为保障账号安全，请绑定手机号",
        currentAccount: "当前账号",
        desc: "尚未绑定手机号。绑定后可使用手机号快捷登录，并保障账号安全。",
        notice: "为保障账号安全，绑定手机号后才能使用平台",
      },
      messages: {
        inviteLoadFailed: "邀请码获取失败",
        enterPhoneFirst: "请先输入手机号",
        enterPhone: "请输入手机号",
        invalidPhone: "请输入正确的手机号",
        codeSent: "验证码已发送",
        enterCode: "请输入验证码",
        enterNewPassword: "请输入新密码",
        enterConfirmPassword: "请再次输入新密码",
        passwordMismatch: "两次输入的新密码不一致",
        passwordResetSuccess: "密码重置成功",
        passwordResetFailed: "密码重置失败",
        loginSuccess: "登录成功",
        registerSuccess: "注册成功",
        invalidLoginState: "登录状态异常，请重新登录",
        bindPhoneFailed: "绑定手机号失败",
        enterInvitation: "请输入邀请码",
        enterCompanyName: "请输入企业名称",
        enterAccount: "请输入账号",
        enterPassword: "请输入密码",
      },
    },
    teamInvite: {
      close: "关闭团队邀请注册弹窗",
      loading: "正在加载邀请信息...",
      retry: "重试",
      loadFailed: "邀请链接无效或已过期，请联系邀请人重新获取",
      codeFailed: "验证码发送失败，请稍后重试",
      registerFailed: "注册失败，请稍后重试",
      title: "{name}团队的邀请链接",
      titleFallback: "团队邀请链接",
      subtitle: "完成注册后即可一键加入团队",
      passwordMin: "密码至少 6 位",
      agreementPrefix: "注册即代表同意",
      details: {
        teamName: "企业名称",
        accountLevel: "账号层级",
        businessRole: "业务角色",
        parentAdmin: "所属管理员",
      },
      fields: {
        phone: "手机号",
        code: "验证码",
        password: "密码",
        confirmPassword: "确认密码",
      },
    },
    partners: {
      title: "AIGC 创意合作伙伴",
      desc: "汇聚全球 AIGC 先锋创作者，以 AI 赋能创意表达，打破传统制作边界。",
      featuredCreator: "本期推荐创作者",
      featuredWork: "精选作品",
      featuredWorkAlt: "{name}精选作品",
      creatorAria: "查看{name}的创作者资料",
      items: {
        0: {
          name: "泫九",
          headline:
            "第八届初心榜AIGC年度杰出十大人物（中国电视剧制作产业协会、首都视听产业协会）",
          bio: "入围IM两岸青年影展（福建省电影局、福建省广播电视局、福建省广播影视集团）\n第六届马栏山杯-金奖（芒果卫视主办）\nParallel Worlds-金奖（B站主办）\n第三届上海国际AIGC-二等奖（上海市嘉定南翔人民政府主办）\nWANMUSE+ 全球创作大赛第一季-最佳视觉奖（阿里主办）",
        },
        1: {
          name: "宁同学",
          headline:
            "视觉设计师 · AIGC创作者\n「大眼镇」系列作品作者 · 即梦 · 小云雀 · 可灵优创",
          bio: "· 2026 ADC 105th Annual Awards BRONZE WINNER（铜奖）\n· 「李白在安陆」诗词短视频创作大赛 视频组 一等奖\n· 佛堂十月十 AIGC 全球短视频创作大赛 一等奖\n· 2025 Team Championship Prompt Battle Grold 金奖\n· 2025 AI视界·影像中国 短视频创作大赛 银奖\n· 第二届全球 AI 视觉创意大赛瓦卡奖 VACAT 图像组 优秀奖",
        },
        2: {
          name: "泫宽",
          headline: "AIGC广告导演 · 故事接龙MCN签约作者 · AI+3D打印农场合伙人",
          bio: "PixVerse 超创 · 豆包 · 即梦成长计划 · 元极AI 等签约艺术家\n工信部AIGC专业级 · 前上海电视台纪实人文频道责编 · 上影AIGC讲师\n\n合作品牌：上汽智己、豆包、中国人寿、比亚迪、京东、吉利、洋河、国台等",
        },
        3: {
          name: "NONOPark",
          headline:
            "视觉导演 · AI视频创作 · NONO Park（泫宗 泫一个） · 易点天下深度合作 · 片头宣传片 · 电商产品视频",
          bio: "大家好，我是泫宗 泫一个，网名—：“NONO Park”一名专注于AI视频创作的视觉导演与内容创作者。我致力于将前沿的AI技术与视觉艺术深度融合，探索视频内容生产的全新边界。\n\n在AI视觉创作领域，我有着扎实的实战经验和商业落地能力。此前，我曾带作品参加苏州科技园举办的“AI无界·科创赋能-AI视觉创作”大赛，并成功斩获入围奖。这次经历不仅是对我AI创作能力的认可，也让我对科技赋能视觉艺术有了更深的理解。\n\n在商业合作方面，我目前与出海营销头部企业“易点天下”保持着深度的绑定合作。在合作期间，我主要负责AI短视频的跑通测试、规模化制作与高质量交付。这让我积累了丰富的商业级项目管理经验，能够精准把控从前期概念测试到最终成片交付的每一个环节。\n\n在内容创作上，我尤其擅长片头宣传片以及电商产品视频宣传的AI生成与制作。通过熟练运用各类AI视频工具，我不仅能大幅提升视频制作的效率，还能为品牌和产品赋予极具视觉冲击力和科技感的呈现效果，助力商业转化。\n\n我始终相信AI是创作者最强大的画笔。期待未来能与更多优秀的团队和伙伴交流合作，共同探索AI视频创作的无限可能！",
        },
        4: {
          name: "伊达",
          headline: "个人AIGC创作者 · 工信部认证AIGC高级艺术家 · 多平台超创",
          bio: "前国有银行总行级内训师\n\n· ISMA2025 三等奖\n· 百度 AI 追热季 S1 赛季 商业创意奖\n· 国内多个平台赛事奖项",
        },
        5: {
          name: "MK",
          headline:
            "AIGC创作者 · 即梦AI成长计划 · 抖音签约创作者\nFlova.ai 新锐创作者",
          bio: "深耕 AIGC 视觉创作领域，擅长运用各类 AI 工具进行视觉表达与内容生产。\n\n· 海合安首届 AIGC 创意挑战大赛 蓝色星球创新奖\n· 2024 世界人工智能大会 WAIC 美好奇妙世界 AI 绘画大赛 一等奖",
        },
        6: {
          name: "泫三十",
          headline: "国内AIGC赛道领军人物 · 海螺AI/拍我AI超级创作者",
          bio: "拥有二十余年影视全流程经验，历任技术总监、执行导演、总导演、总制片等职，主导百余项传统影视项目。为多平台签约作家，著书十数部，累计近千万字，作品多次登顶榜单；兼具AI音乐创作资质；参编国家“十四五”规划教材。斩获北京电影学院、大湾区电影展、硅谷AI电影节、网易、腾讯等国内外重磅AIGC与影视大奖，技术、创作、制片能力突出。",
        },
        7: {
          name: "泫宗 2046",
          headline: "一名普通的剪辑师",
          bio: "获奖：我ai北京荣获优秀奖，作品曾上过北京日报。温州谢灵运ai比赛荣获优秀奖",
        },
        8: {
          name: "泫宗尼古猫",
          headline:
            "尼古猫【多平台优质创作者、长治Ai红色题材金奖、冷湖科幻赛道银奖、可灵X阅文十周年角逐IP之光大赛三等奖】",
          bio: "",
        },
        9: {
          name: "泫宗 百宝阁",
          headline: "佛系AI玩家 · 多项AIGC大赛前三",
          bio: "一位佛系AI玩家，曾在以下大赛中都获得至少前三的奖：中国台湾光复80周年暨祖国统一AIGC短片创作大赛、“小马过河杯”AIGC寓言创作大赛、廊桥AI出海视频创作大赛、“楠溪创享家”AI视频创作大赛、“益路同行”中国公益出海AI动画短片大赛等一系列大赛，小赛就不多说了",
        },
        10: {
          name: "不近视的猫",
          headline:
            "万粉公众号博主 · 海螺AI超创 · Flova.ai 超创 · Vidu艺术家 · 可灵优质创作者",
          bio: "微博AI视频创作大赛次元赛道最佳作品；百度春节创作赛铜奖；作品在第一届Redstar计划大会“优秀AI影视作品”展映。",
        },
        11: {
          name: "泫宗 忘记",
          headline:
            "可灵优秀创作者；和平精英签约AIGC作者；剪映Ai创意视频第一期优质创作者",
          bio: "",
        },
        12: {
          name: "泫宗迷途",
          headline: "AIGC 时代的传媒创作者 · 技术为笔 · 创意为核",
          bio: "探索视频内容的全新表达边界，服务政务、媒体、商业三大赛道，合作浙江省卫健委、浙江省纪委、河南广电、杭州日报、中国电信、吉利汽车等数十家政企，打造多项创新 AI 视频精品。作品曾荣获伊利、柒牌、杭州日报等平台 AI 视频大赛奖项。",
        },
        13: {
          name: "梁米啦",
          headline: "AIGC导演/数字艺术家/编剧/心理咨询师",
          bio: "故事接龙MCN签约作者｜LibTV、漫枢等平台超级创作者\n\n2022年进入AIGC创作领域，作品覆盖剧情短片、科幻视效、奇幻儿童冒险、治愈MV、TVC广告、文旅宣传、短剧、IP二创及短剧视觉开发等多个领域。\n\n2022年首批入局AIGC的探索者，曾获重庆春晚AIGC创意大赛一等奖、乘风2026AIMV优秀奖、可灵AI创意MV挑战赛二等奖、VGS世界AI视频大赛铜奖等几十项奖项/入围。影视IP二创作品曾获相关主创评论互动。",
        },
        14: {
          name: "泫宗崔一下",
          headline: "大型天然气集团首席AI设计师｜工信部AI视觉设计师(高级)",
          bio: "现任大型天然气集团首席AI设计师，工信部AI视觉设计师(高级)。AI视频爱好者。",
        },
        15: {
          name: "泫宗水之心",
          headline: "心水映画创始人 · AI与影视内容创新者",
          bio: "心水映画（水之心）是专注 AIGC 视觉叙事的专业创作品牌，创始人朱钦兼具中科大扎实理工功底、完整影视制作经验，曾任职芒果 TV、世界五百强企业，拥有新媒体全链路创业实战经历，打通技术与内容创作壁垒。\n\n品牌主营 AI 短剧、品牌 AI 广告、AI 电影、文旅宣传片，服务国企、医疗、国际品牌等多领域客户，产出多部全网播放量破亿的爆款内容，形成成熟可复制的 AI 内容工业化体系。\n\n团队斩获马栏山 AI 大赛金奖、全球数字经济创新大赛新星奖等多项权威荣誉，融合东方水墨美学与前沿 AI 技术，以智能化手段赋能影像创作，持续探索数字视觉新表达。",
        },
      },
    },
    product: {
      heroImageAlt: "AIGC漫剧创作管理平台",
      floatTags: {
        data: "全球内容大数据",
        insight: "爆款洞察模型",
        script: "剧本AI创作",
        asset: "资产导演模型",
        video: "一键成片系统",
      },
      eyebrow: "产品服务",
      titlePrefix: "AIGC漫剧创作",
      titleAccent: "管理平台",
      subtitle: "剧本到成片，一站式 AI 漫剧创作与管理",
      cta: "立即体验",
      ctaHint: "注册即可免费试用核心功能",
      capabilities: "六大核心能力",
      detail: "查看详情",
      services: {
        data: {
          title: "AI爆款漫短剧大数据平台",
          tagline: "4.2万亿赛道，先发制胜",
          desc: "全球多模态大数据引擎、爆款预测与趋势捕捉，从选题洞察到投产预判，帮助创作者锁定下一部爆款。",
        },
        production: {
          title: "AI影视动漫制作管理平台",
          tagline: "剧本到成片，24 小时极速交付",
          desc: "AI 解析剧本自动生成分镜，角色资产全剧复用，文生图、图生视频、分镜切片、合成预览全链路覆盖。",
        },
        copyright: {
          title: "版权一站式登记平台",
          tagline: "AI 作品确权，唯快不破",
          desc: "打通 AI 剧本版权登记难题，每一部作品生成即确权，构建海量 IP 资产的长期竞争优势。",
        },
        filing: {
          title: "漫剧/短剧一键备案平台",
          tagline: "稀缺牌照，独家通道，合规无忧",
          desc: "网络视听许可证与短剧备案能力接入平台，一键完成合规备案，让创作者只关心创作。",
        },
        distribution: {
          title: "全球多平台发行",
          tagline: "一键分发 100+ 国家",
          desc: "多语种 AI 自动翻译配音与海外平台矩阵覆盖，从本地到全球，一次制作、一键分发。",
        },
        commercialization: {
          title: "IP衍生商业化",
          tagline: "从内容到资产，释放长尾价值",
          desc: "角色 IP 孵化、虚拟形象授权、消费品开发与全球版权交易，搭建内容变现闭环。",
        },
      },
    },
    about: {
      title: "关于我们",
      vision: "愿景：让每一个好故事，都能让世界看见。",
      mission: "使命：用AI重塑内容工业化，赋能全球创作者。",
      contact: "联系我们",
      customerServiceWechat: "客服微信",
      customerServiceWechatQr: "客服微信二维码",
      follow: "关注我们",
      socialQrAlt: "{name}二维码",
      companyAddress:
        "合肥漫域巅峰科技有限公司 ｜ 地址：安徽省合肥市望江西路535号云掌大厦B座2层",
      social: {
        douyin: "抖音",
        videoAccount: "视频号",
        wechatOfficial: "公众号",
        xiaohongshu: "小红书",
        weibo: "微博",
        bilibili: "哔哩哔哩",
      },
      paragraphs: [
        "漫枢平台是由合肥漫域巅峰科技有限公司精心打造，构建全球AI影视动漫工业化生态系统，打造全球领先的AI内容“快时尚”引擎。公司由中国顶级的影视广告营销大数据技术专家、国内超一流的动漫制作团队以及国内一流的资本运作团队联合创办。",
        "漫枢生态体系包括：全球内容大数据SAAS平台、AI创意大脑中心SAAS平台、漫短剧制作管理SAAS平台、爆款内容预测模型、爆款内容工厂、漫短剧商业化平台、产教融合体系、内容版权登记平台、基于网络视听许可证牌照的播出&备案管理平台、全球内容出海和发行等。",
        "漫枢重点解决了创作者如何做得快、做得好、卖得掉、赚得多的全链路问题。",
        "公司主营的八大业务矩阵，相关串联、相互关联，SAAS工具的三个版本覆盖全行业的创作者和潜在创作者群体，以基于大数据的影视动漫制作工具为核心，结合影视、动漫、广告营销和学校教育等公司具备丰富资源的领域，进行主营业务的发展和裂变。",
        "公司核心团队参与国家“十五五”的12本AIGC系列教材的编制，是唯一企业参与教材编制的单位。在权威性和标准建立方面拥有先天优势。通过我们独创的ZARA内容工厂模式，打造海量原创IP的爆款内容和全球发行，通过集团的版权登记资质和网络视听许可证牌照，形成天然的竞争壁垒，以此建立独有的商业模式和差异化竞争。",
        "漫枢通过自主研发的核心技术打造三大影视营销模型：Manyutop-Mind（文本模型）、Manyutop-Vision（图像模型）、Manyutop-Motion（视频模型），在通用大模型的基础上，通过微调、领域知识库建立和行业Skills运用，在底层能力上大幅度超越行业主流工具，为后续的市场爆发打下坚实的基础。",
        "漫枢的客户群体包括：漫短剧公司、影视公司、创作者、MCN公司、广告营销公司、媒体、品牌方等。",
      ],
    },
  },
  auth: {
    loginExpired: "登录状态已失效，请重新登录",
    otherDeviceLogin: "当前账号目前在其他设备上登录，请注意账号安全",
    accountFrozen: "账号已被冻结，请联系管理员",
  },
  route: {
    home: "首页",
    scriptPage: "剧本页",
    storyboard: "分镜编辑",
    scriptPreview: "分镜预览",
    copywritingCreation: "剧本创作",
    detectionResult: "探测结果页",
    myProject: "我的项目",
    projectManagement: "片段管理",
    hotRanking: "热门榜单",
    statisticalDimension: "统计维度",
    visionCanvas: "泫宗画布",
    visionCanvasEditor: "泫宗画布编辑",
    projectGroupWorkbench: "项目组工作台",
    roleManagement: "角色管理",
    sceneManagement: "场景管理",
    propManagement: "道具管理",
    login: "登录",
    projectGroupInvite: "项目组邀请",
    userManagement: "用户管理",
    teamManagement: "团队管理",
    invoice: "订单管理",
  },
  invoiceCenter: {
    view: "查看",
    reissue: "重开",
    resend: "重发到邮箱",
    resendSuccess: "发票邮件已重发",
    resendFailed: "发票邮件重发失败，请稍后重试",
    resendConfirm: {
      title: "重发到邮箱",
      message: "确定将该发票重新发送到收票邮箱吗？",
    },
    reissueDialog: {
      title: "重新开票",
      submit: "确认重开",
      loadFailed: "原发票信息加载失败，请稍后重试",
      submitSuccess: "重开申请已提交",
      submitFailed: "重开申请提交失败，请稍后重试",
    },
    detail: {
      title: "发票详情",
      invoiceInfo: "开票信息",
      orderInfo: "订单信息",
      purchaserType: "购买方类型",
      taxpayerNumber: "纳税人识别号",
      invoiceCode: "发票代码",
      invoiceNumber: "发票号码",
      allElectronicInvoiceNumber: "全电发票号码",
      failureReason: "失败原因",
      invoiceFile: "发票文件",
      download: "下载发票",
      orderAmount: "订单开票金额",
      emptyOrders: "暂无关联订单",
      close: "关闭",
      loadFailed: "发票详情加载失败，请稍后重试",
    },
    title: "订单管理",
    subtitle: "查看可开票订单和历史开票记录",
    tabs: {
      paidOrders: "已支付订单",
      history: "开票历史",
    },
    refresh: "刷新",
    loading: "加载中",
    emptyOrders: "暂无已支付订单",
    emptyHistory: "暂无开票历史",
    loadFailed: "发票数据加载失败，请稍后重试",
    columns: {
      orderNo: "订单号",
      payDescription: "订单描述",
      payTime: "支付时间",
      paidAmount: "支付金额",
      invoiceAmount: "开票金额",
      orderStatus: "开票状态",
      applyNo: "开票申请号",
      purchaserName: "发票抬头",
      invoiceStatus: "发票状态",
      createTime: "申请时间",
      issueTime: "开具时间",
      actions: "操作",
    },
    apply: "开发票",
    unavailable: "当前订单不可开票",
    submitSuccess: "开票申请已提交",
    submitFailed: "开票申请提交失败，请稍后重试",
    dialog: {
      title: "申请开发票",
      orderNo: "订单号",
      amount: "开票金额",
      purchaserType: "购买方类型",
      personal: "个人",
      enterprise: "企业",
      category: "发票种类",
      normalInvoice: "电子普通发票",
      specialInvoice: "电子专用发票",
      purchaserName: "发票抬头",
      purchaserNamePlaceholder: "请输入个人姓名或企业名称",
      taxpayerNumber: "纳税人识别号（企业必填）",
      taxpayerNumberPlaceholder: "请输入企业纳税人识别号",
      address: "购买方地址（选填）",
      phone: "购买方电话（选填）",
      bank: "开户银行（选填）",
      bankAccount: "银行账号（选填）",
      mobile: "接收手机号（选填）",
      mobilePlaceholder: "用于接收电子发票通知",
      email: "接收邮箱（选填）",
      emailPlaceholder: "用于接收电子发票通知",
      cancel: "取消",
      submit: "提交申请",
    },
    validation: {
      purchaserType: "请选择购买方类型",
      category: "请选择发票种类",
      purchaserName: "请输入发票抬头",
      taxpayerNumber: "请输入纳税人识别号",
      email: "请输入正确的邮箱地址",
    },
    status: {
      UNINVOICED: "未开票",
      SUBMITTING: "待提交开票申请",
      ISSUING: "开票中",
      ISSUED: "已开票",
      RED_PROCESSING: "红冲处理中",
      ISSUE_FAILED: "开票失败",
      RED_REQUESTED: "红冲中",
      RED_ISSUED: "已红冲",
      RED_FAILED: "红冲失败",
      REISSUE_WAITING_RED: "等待原票红冲",
    },
  },
  workflow: {
    steps: {
      script: "剧本",
      assets: "资产",
      storyboard: "分镜视频",
      compose: "一键成片",
    },
    actions: {
      next: "下一步",
      parseScript: "解析剧本",
      autoStoryboard: "自动拆分镜",
      preview: "预览",
    },
    script: {
      projectName: "项目名称",
      episode: "片段",
      aspectRatio: "比例选择",
      ratio: "比例",
      style: "风格选择",
      myScript: "我的剧本",
      placeholder: "输入当前片段的剧本内容（非必填）",
      defaultSettingsTip:
        "所选参数作为后续创作的默认值，支持修改。可选择输入剧本内容自动提取资产和分镜，也可选择不输入剧本，点击下一步，手动创建资产和分镜。",
      assetNextTip: "点击下一步，进入分镜视频页面，可创建分镜图片和分镜视频",
      assetAutoTip:
        "点击自动拆分镜，将根据剧本和资产，自动生成分镜图片和分镜视频",
    },
    scriptPage: {
      previewImage: "预览图片",
      favorite: "收藏",
      favoriteImage: "收藏图片",
      selectImage: "选择图片",
      selectVideo: "选择视频",
      records: "记录",
      materials: "素材",
      favorited: "已收藏",
      selected: "已选择",
      uploadImage: "上传图片",
      dragFile: "将文件拖到此处，或",
      clickUpload: "点击上传",
      imageAlt: "图片 {id}",
      videoAlt: "视频 {id}",
      imageGenerationFailed: "图片生成失败",
      videoGenerationFailed: "视频生成失败",
      generating: "生成中...",
      imageRecordsHint:
        "提示：点击缩略图可预览大图，点击星标可收藏图片，点击勾选可选择图片",
      videoRecordsHint: "提示：点击缩略图可预览视频，点击勾选可选择视频",
      materialsHint: "提示：点击素材可选中，点击删除可移除素材",
      audioUnsupported: "您的浏览器不支持 audio 标签",
      addImage: "添加图片",
      imageFormatHint: "支持 PNG、JPG、JPEG、BMP，最大 10MB",
      outputImageCount: "输出图片张数",
      outputVideoCount: "输出视频数量",
      generateImage: "生成图片",
      generateVideo: "生成视频",
      pointsCost: "消耗 {count} 积分",
      materialImage: "素材图片",
      audioMaterial: "音频素材",
      noPreview: "暂无预览",
      draftVideo: "草稿视频",
      imageSettings: "生图参数设置",
      videoSettings: "生视频参数设置",
      imageCount: "生图数量",
      videoCount: "生视频数量",
      startGenerate: "开始生成",
      noRecordsOrMaterials: "暂无记录/素材，您可尝试生成或上传",
      batchGenerateMedia: "批量生成{media}",
      confirmBatchGenerate: "是否批量生成{media}",
      memberSettings: "成员设置",
      username: "用户名",
      usernamePlaceholder: "请输入用户名",
      projectMembers: "项目成员：{count}人",
      assignImageAndVideo: "是否同时分配图片和视频分镜",
      role: "角色",
      rejectData: "打回数据",
      rejectReason: "打回原因",
      rejectReasonPlaceholder: "请输入打回原因，Ctrl + V 粘贴图片",
      uploading: "上传中...",
      custom: "自定义",
      dialogueTypes: {
        lipSync: "含口型",
        narration: "旁白",
        innerMonologue: "内心独白",
      },
      shotSizes: {
        0: "大远景",
        1: "远景",
        2: "全景",
        3: "中景",
        4: "中近景",
        5: "近景",
        6: "大特写",
      },
      pointsFailed: "获取{media}消耗积分失败",
      imageMax5MB: "图片不能超过 5MB",
      approveConfirm: "是否通过当前数据？",
      approveTitle: "确定通过",
      selectAssignee: "请选择要分配的角色",
      assignmentSuccess: "分配成功",
      selectStoryboardsToAssign: "请选择要分配的分镜",
      imageRequestFailed: "图片生成请求失败",
      requestFailed: "请求失败 😿",
      addLastFrame: "请添加尾帧图片",
      operationFailed: "操作失败",
      voiceMissingTitle: "声音未设置",
      voiceMissingMessage:
        "提示：尚有人物未选择声音，分镜提示词不会生成该人物的音频引用，需要您手工引用人物声音，是否继续拆分镜？",
      continueStoryboardSplit: "继续拆分镜",
      taskTimeout: "任务处理超时，请稍后刷新页面查看进度",
      storyboardGenerationFailed: "分镜生成失败",
      scriptParsingFailed: "剧本解析失败",
      supportedMaterialTypesOnly: "只能上传音频、视频或图片",
      uploadFailedWithReason: "上传失败：{reason}",
      serverError: "服务器异常",
      imageUploadFailed: "图片上传失败",
      imageUploadingWait: "图片正在上传，请等待上传成功后再保存",
      imageMustUploadBeforeSave: "图片上传成功后才能保存",
    },
    storyboard: {
      images: "分镜图片",
      videos: "分镜视频",
      imageTab: "图片",
      videoTab: "视频",
      item: "分镜",
      itemName: "分镜 {label}",
      list: "分镜列表",
      add: "新增分镜",
      batchDownload: "批量下载",
      composeTip:
        "预览可快速浏览分镜视频连贯效果；一键成片将已有视频的分镜自动剪辑为完整视频",
    },
    storyboardList: {
      expandPrompt: "展开",
      collapsePrompt: "收起",
      noPrompt: "暂无提示词",
      editStoryboard: "编辑分镜",
      splitStoryboard: "拆分镜",
      more: "更多",
      waitingVideo: "等待视频生成",
      generatingProgress: "生成中 {current}/{total}",
      labels: {
        model: "模型",
        shotSize: "景别",
        dialogue: "台词",
        characters: "涉及角色",
        ratio: "比例",
        voice: "音色",
        scenes: "涉及场景",
        props: "涉及道具",
        operator: "操作人",
        reviewer: "审核人",
        cameraMovement: "相机运动",
        lipSync: "口型同步",
        videoMode: "生视频方式",
      },
      yes: "是",
      no: "否",
      videoModes: {
        prompt: "全能参考",
        firstFrame: "首帧",
        firstLast: "首尾帧",
      },
      media: {
        image: "图片",
        video: "视频",
        audio: "音频",
      },
      submitReview: "提交审核",
      approve: "通过",
      reject: "打回",
      insertBefore: "在当前镜头前插入",
      insertAfter: "在当前镜头后插入",
      messages: {
        selectStoryboard: "请选择分镜",
        selectStyle: "请选择风格",
        batchConfirm:
          "批量生成将统一使用当前选择的模式和模型，会覆盖<br>已编辑过的分镜内容，是否继续？",
        batchStarted: "批量生成已开始，正在处理中...",
        batchRequestFailed: "批量生成请求失败",
        noPreviewVideos: "暂无可预览的分镜视频，请先生成分镜视频",
        previewFailed: "获取预览失败",
        noComposeVideos: "暂无可成片的分镜视频，请先生成分镜视频",
        composeFailed: "一键成片失败",
        reviewTitle: "确认提交审核？",
        reviewConfirm:
          "提交后，当前数据将进入待审核状态，无法再次编辑，直到管理员审核通过或打回",
        downloadFailed: "下载失败",
        deleteConfirm: "确定删除这个分镜吗？",
        deleteMediaConfirm: "确定删除这个{media}吗？",
        added: "添加成功",
        deleted: "删除成功",
      },
    },
    batchGenerate: {
      close: "关闭",
      selectModel: "选择模型",
      selectVersion: "选择版本",
      resolution: "分辨率",
      style: "风格",
      ratio: "比例",
      background: "背景",
      backgroundAuto: "自动",
      backgroundOpaque: "保留背景",
      backgroundTransparent: "透明背景",
      duration: "时长",
      noModels: "暂无可选模型",
      noVersions: "暂无可选版本",
      noResolutions: "暂无可选分辨率",
      noStyles: "暂无可选风格",
      noRatios: "暂无可选比例",
      generate: "批量生成",
      calculating: "计算中",
      imageTitle: "批量生成分镜图片",
      videoTitle: "批量生成分镜视频",
      firstFrame: "首帧",
      referenceVideo: "参考生视频",
      all: "全部",
      pointsFailed: "获取批量生成积分失败",
      validation: {
        model: "请选择模型",
        version: "请选择版本",
        resolution: "请选择分辨率",
        style: "请选择风格",
        ratio: "请选择比例",
        duration: "请选择时长",
      },
    },
    previewPanel: {
      loading: "视频加载中",
      empty: "暂无可预览的分镜视频",
      model: "模型",
      ratio: "比例",
      quality: "清晰度",
      style: "风格",
      noStyleLimit: "不限制风格",
      compose: "一键成片",
      missingScriptParams: "缺少剧本参数",
      noVideo: "无视频",
      storyboard: "分镜 {id}",
      download: "下载合成视频",
      composing: "正在合成视频 {progress}%",
      loadingComposer: "正在加载合成组件",
      filename: "成片-{id}.mp4",
      downloadStarted: "开始下载合成视频",
      downloadFailed: "下载失败",
      errors: {
        network: "网络异常，无法连接预览服务",
        resourceLoad: "视频资源加载失败，可能是跨域或链接失效",
        composerNetwork: "视频合成组件加载失败，请检查网络后重试",
        composerRefresh: "视频合成组件加载失败，请刷新页面后重试",
        apiNoResponse: "预览接口无响应，请检查网络或后端服务",
        fetchFailed: "获取预览失败",
        playbackFailed: "视频合成播放失败",
      },
    },
    storyboardWorkspace: {
      storyboard: "分镜",
      storyboardName: "分镜 {label}",
      selectShot: "请选择分镜后开始编辑",
      expand: "放大",
      collapse: "收起",
      expandList: "展开分镜列表",
      collapseList: "收起分镜列表",
      firstFrame: "首帧",
      lastFrame: "尾帧",
      reference: "参考",
      expandAllReferences: "展开全部",
      collapseReferences: "收起",
      select: "选择",
      addToReferences: "添加到参考素材",
      download: "下载",
      fullscreen: "全屏",
      draft: "草稿",
      failed: "失败",
      notGenerated: "未生成",
      history: "生成历史",
      noHistory: "暂无生成记录",
      generate: "生成",
      regenerate: "重新生成",
      promptOptimize: "提示词优化",
      promptOptimizeResultTitle: "优化后的提示词",
      promptOptimizeFill: "填充到输入框内",
      promptOptimizeCopy: "复制",
      promptOptimizeCopied: "复制成功",
      promptOptimizeCopyFailed: "复制失败",
      promptOptimizeFailed: "提示词优化失败",
      promptOptimizeEmpty: "未获取到优化后的提示词",
      promptOptimizeEmptyPrompt: "请先输入提示词",
      generateFailed: "{media}生成失败",
      paramsMissing: "分镜参数缺失",
      unsavedLeaveTitle: "存在未保存的分镜",
      unsavedLeaveMessage:
        "以下分镜尚未保存：{shots}。离开后本地缓存将被清除，是否继续离开？",
      confirmLeave: "继续离开",
      continueEditing: "继续编辑",
      roleAssetReviewTitle: "角色图片审核提醒",
      roleAssetReviewMessage:
        "检测到引用角色绑定的图片未通过人员审核，是否继续生成？",
      continueGenerate: "继续生成",
      firstLastPromptReferenceInvalid:
        "提示词中引用的参考图在首尾帧生成模式无效，是否继续生成",
      roleAssetCheckFailed: "角色图片审核状态检查失败",
      media: { image: "图片", video: "视频", audio: "音频" },
      /** 分镜单文件上传限制（格式/大小/边长/时长等） */
      fileValidate: {
        listSeparator: "、",
        lessThan: "小于",
        noMoreThan: "不超过",
        kind: { image: "图片", video: "视频", audio: "音频" },
        onlyMedia: "仅支持图片、视频或音频",
        unrecognizedFormat: "无法识别文件格式",
        imageFormatOnly:
          "图片格式仅支持 jpeg、png、webp、bmp、tiff、gif、heic/heif",
        videoFormatOnly: "视频格式仅支持 mp4、mov",
        audioFormatOnly: "音频格式仅支持 wav、mp3",
        sizeNeed: "{kind}大小需{comparator} {size}（实际大小: {actual}）",
        cannotReadImageSize: "无法读取图片尺寸，请检查文件是否损坏",
        cannotDecodeImageFormat:
          "无法解析该 {format} 图片，请转换为 jpeg 或 png 后重试",
        cannotReadVideoSize: "无法读取视频尺寸，请检查文件是否损坏",
        imageWidthTooSmall: "图片宽度不足 {min} 像素，请放大或更换后重试",
        imageWidthTooLarge: "图片宽度超过 {max} 像素，请缩小后重试",
        imageHeightTooSmall: "图片高度不足 {min} 像素，请放大或更换后重试",
        imageHeightTooLarge: "图片高度超过 {max} 像素，请缩小后重试",
        videoEdgeRange: "视频宽高需在 {min}–{max}px 之间",
        imageAspectRange: "图片宽高比需在 {min}–{max} 之间",
        videoAspectRange: "视频宽高比需在 {min}–{max} 之间",
        videoPixelsRange: "视频总像素需在 {min}–{max} 之间",
        videoPixelsTooLarge:
          "当前约 {actualLabel}（{width}×{height}），超出允许范围（约 {range}）",
        videoPixelsTooSmall:
          "当前约 {actualLabel}（{width}×{height}），低于允许范围（约 {range}）",
        videoResolutionOnly:
          "视频分辨率需在 {resolutions} 之间（当前分辨率: {actual}）",
        cannotReadVideoDuration: "无法读取视频时长，请检查文件是否损坏",
        cannotReadAudioDuration: "无法读取音频时长，请检查文件是否损坏",
        videoDurationRange:
          "视频时长需在 {min}–{max}s 之间（实际时长: {actual}s）",
        audioDurationRange:
          "音频时长需在 {min}–{max}s 之间（实际时长: {actual}s）",
        cannotReadVideoFps: "无法读取视频帧率，请检查文件是否损坏",
        videoFpsRange:
          "视频帧率需在 {min}–{max} FPS 之间（实际帧率: {actual}）",
        untitledFile: "未命名文件",
        fileFailedDetail: "「{fileName}」{message}",
      },
      messages: {
        noOperableRecord: "暂无可操作的生成记录",
        selectSuccess: "选择成功",
        selectCancelled: "已取消选择",
        operationFailed: "操作失败",
        noDeletableRecord: "暂无可删除的生成记录",
        deleteSuccess: "删除成功",
        deleteFailed: "删除失败",
        deleteDraftFailed: "删除草稿失败",
        noSavableImage: "暂无可保存的生成图片",
        referenceLimitReached:
          "当前参考已达到上限{count}个，请先删除参考再进行添加",
        referenceImageModeLimitReached:
          "当前参考已达到上限{count} 张，请先删除参考再进行添加",
        referenceImageLimitReached:
          "当前参考图片已达到上限{count}个，请先删除参考再进行添加",
        referenceVideoLimitReached:
          "当前参考视频已达到上限{count}个，请先删除参考再进行添加",
        referenceAudioLimitReached:
          "当前参考音频已达到上限{count} 个，请先删除参考再进行添加",
        unsupportedMedia: "仅支持上传图片、视频或音频",
        addedToReferences: "已添加到参考素材",
        addFailed: "添加失败",
        noDownloadable: "暂无可下载的{media}",
        promptPlaceholder: "请输入提示词",
        referenceMaterial: "参考素材",
        uploadFailed: "上传失败",
        paramsMissing: "分镜参数缺失",
        imageOnlyMode: "当前模式只能上传图片",
        imageModeImagesOnly: "图片模式只能上传图片",
        referenceBatchMax10: "单次最多上传{count}个文件",
        getModelsFailed: "获取模型列表失败",
        getModelParamsFailed: "获取模型参数失败",
        getPointsFailed: "获取消耗积分失败",
        selectStyle: "请选择风格",
        addFirstLastFrames: "请添加首帧-尾帧图片",
        addFirstFrame: "请添加首帧图片",
        saveFailed: "保存失败",
        saveSuccess: "保存成功",
        generatingInProgress: "当前分镜正在生成中，请等待生成完成后再试",
        generateStarted: "已开始生成",
        generateFailed: "生成失败",
        /** 保存/生成前置校验期间切换了分镜、Tab 或生成记录，本次操作取消 */
        generateCancelledOnSwitch:
          "提交过程中切换了分镜或生成记录，分镜 {label} 的本次生成已取消，请回到该分镜重新生成",
        saveCancelledOnSwitch:
          "提交过程中切换了分镜或生成记录，分镜 {label} 的本次保存已取消，请回到该分镜重新保存",
      },
      modes: {
        reference: "全能参考",
        firstLast: "首尾帧",
        first: "首帧",
      },
      promptHint: {
        reference:
          "可上传参考内容。提示词 输入“@”可引用角色、场景、道具、素材。",
        firstFrame:
          "提示词 上传作为首帧的图片。输入“@”可引用角色、场景、道具、素材。",
        firstLast:
          "上传作为首/尾帧的图片。提示词输入“@”可引用角色、场景、道具、素材。",
      },
      reviewStatus: {
        legend:
          "上传参考会自动仿真人审核，绿色表示审核通过，红色代表审核失败，黄色审核中",
      },
      config: {
        noModels: "暂无可用模型",
        noStyles: "暂无可用风格",
        resolution: "分辨率",
        ratio: "比例",
        background: "背景",
        backgroundAuto: "自动",
        backgroundOpaque: "保留背景",
        backgroundTransparent: "透明背景",
        quality: "清晰度",
        duration: "视频时长",
        quantityValue: "{count}张",
        quantityValueVideo: "{count}个",
        points: "积分",
        selectModel: "选择模型",
        selectStyle: "选择风格",
        allStyles: "全部风格",
        parameters: "参数",
      },
      audioPreview: "音频预览",
      mention: {
        search: "输入关键字搜索",
        empty: "暂无数据",
        tabs: { reference: "参考", asset: "资产", material: "素材" },
        assetFilters: { role: "人物", scene: "场景", prop: "道具" },
        assetSource: { script: "片段", project: "项目" },
        materialFilters: {
          all: "全部",
          other: "其他",
          character: "人物",
          scene: "场景",
          item: "物品",
          style: "风格",
          sound: "音效",
          project: "项目空间",
        },
        // 同一提示词里素材与其他 @ 重名时的自动改名
        sameNameAlias: {
          image: "{name}（图片）",
          video: "{name}（视频）",
          audio: "{name}（音频）",
        },
        sameNameAliasIndexed: {
          image: "{name}（图片{index}）",
          video: "{name}（视频{index}）",
          audio: "{name}（音频{index}）",
        },
      },
      videoModelLimits: {
        maxImages: "当前模型引用图片不能超过{count}张",
        maxVideos: "当前模型引用视频不能超过{count}个",
        maxAudios: "当前模型引用音频不能超过{count}个",
        maxTotal: "当前模型引用图片/视频/音频总数不能超过{count}个",
        maxVideoDuration: "当前模型引用视频总时长不能超过{seconds}s",
        maxAudioDuration: "当前模型引用音频总时长不能超过{seconds}s",
        audioNotSupported: "当前模型不支持音频引用",
        maxImageAndVideo: "当前模型图片与视频引用总数不能超过{count}个",
        audioVideoNotSupportedAsReference: "当前模型不支持音频视频作为参考",
        referenceNotSupported: "当前模型不支持引用参考素材",
        maxVideoWithOutputDuration: "当前模型引用视频总时长加生成时长不能超过{seconds}s",
        promptRequired: "当前模型文生视频需要填写提示词",
        untitledFile: "未命名文件",
        fileFailedDetail: "当前模型「{fileName}」{message}",
        animatedNotSupported: "当前模型不支持动图作为参考",
        audioOnlyNotSupported: "当前模型引用参考不能只有音频",
        klingPromptTooLong: "当前模型提示词不能超过{max}个字符",
      },
      imageModelLimits: {
        maxImages: "当前模型引用图片不能超过{count}张",
        animatedNotSupported: "当前模型不支持动图作为参考",
      },
    },
    compose: {
      generating: "视频生成中",
      videoUnsupported: "您的浏览器不支持 HTML5 video 标签。",
    },
    assets: {
      selectAssignData: "请选择要分配的数据",
      batchStarted: "批量生成已开始",
      batchFailed: "批量生成失败",
      generatingCannotDelete: "资产生成中，请等待生成完成后再删除",
      noModels: "暂无可用模型",
      roles: {
        list: "角色列表",
        more: "更多角色",
        batchTitle: "批量生成角色",
        searchPlaceholder: "搜索角色名",
        empty: "暂无角色",
        emptyTip: "点击下方按钮创建你的第一个角色",
        emptySearch: "未找到匹配角色",
        emptySearchTip: "尝试其他关键词搜索",
        create: "创建角色",
        deleteConfirm: "确定删除这个角色吗？",
        selectBatchWarning: "请先勾选要批量生成的角色",
        gender: { unlimited: "不限", male: "男", female: "女" },
        age: {
          unknown: "不详",
          childhood: "幼年",
          child: "儿童",
          teen: "少年",
          young: "青年",
          middle: "中年",
          senior: "老年",
        },
        dialog: {
          createTitle: "创建角色形象",
          editTitle: "编辑角色形象",
          closeTip: "关闭窗口不会中断进行中的任务",
          close: "关闭",
          name: "角色名",
          gender: "性别",
          age: "年龄段",
          enter: "请输入",
          select: "请选择",
          generationMode: "生成方式",
          generateByModel: "通过模型生图",
          uploadImage: "自己上传图片",
          addImage: "添加图片",
          formatHint: "支持 PNG、JPG、JPEG、BMP，最大 10MB",
          model: "选择模型",
          ratio: "比例",
          resolution: "分辨率",
          style: "风格",
          prompt: "提示词",
          promptPlaceholder:
            "请描述角色的外观，包括但不限于性别、年龄、服装、气质等。",
          uploadReference: "上传参考",
          generateImage: "生成图片",
          generatingWarning: "生图期间请勿关闭窗口，关闭将导致图片生成异常。",
          saveChanges: "保存更改",
          voice: "音色",
          preview: "试听",
          pausePreview: "暂停",
          imageCount: "图片数量",
          imageCountValue: "{count}张",
          startGenerate: "点击开始生成",
          calculating: "计算中",
          records: "生图记录",
          recordsHint: "选中记录中的图片后，点击保存，应用该图片。",
          generationFailed: "图片生成失败",
          failed: "生成失败",
          noRecords: "暂无记录",
          saveSettings: "保存设置",
          validation: {
            name: "请输入角色名",
            gender: "请选择性别",
            age: "请选择年龄段",
            prompt: "请输入提示词",
            model: "请选择模型",
            ratio: "请选择比例",
            resolution: "请选择分辨率",
            style: "请选择风格",
          },
          messages: {
            singleFileOnly:
              "只能上传一个文件，如有需要请删除上一个文件再进行上传",
            loginExpired: "登录状态已失效，请重新登录",
            uploadFailed: "上传失败",
            imageUploadFailed: "图片上传失败",
            invalidFormat: "上传的文件格式不正确",
            fileTooLarge: "上传图片大小不能超过 10MB",
            missingImageId: "缺少图片记录ID",
            deleteConfirm: "确定删除这个图片吗？",
            deleteSuccess: "删除成功",
            pointsFailed: "获取消耗积分失败",
            operationFailed: "操作失败",
            saveFailed: "保存失败",
            selectCompletedBeforeSave: "请先选择已生成完成的图片再保存",
            previewUnavailable: "该音色暂无试听音频",
            previewFailed: "音色试听失败",
          },
        },
      },
      scenes: {
        list: "场景列表",
        more: "更多场景",
        batchTitle: "批量生成场景",
        searchPlaceholder: "搜索场景名",
        empty: "暂无场景",
        emptyTip: "点击下方按钮创建你的第一个场景",
        emptySearch: "未找到匹配场景",
        emptySearchTip: "尝试其他关键词搜索",
        create: "创建场景",
        deleteConfirm: "确定删除这个场景吗？",
        selectBatchWarning: "请先勾选要批量生成的场景",
        dialog: {
          createTitle: "创建场景",
          editTitle: "编辑场景",
          closeTip: "关闭窗口不会中断进行中的任务",
          close: "关闭",
          name: "场景名称",
          namePlaceholder: "请输入场景名称",
          select: "请选择",
          generationMode: "生成方式",
          generateByModel: "通过模型生图",
          uploadImage: "自己上传图片",
          addImage: "添加图片",
          formatHint: "支持 PNG、JPG、JPEG、BMP，最大 10MB",
          model: "选择模型",
          ratio: "比例",
          resolution: "分辨率",
          style: "风格",
          prompt: "提示词",
          promptPlaceholder:
            "对场景进行详细描述，如空间、时间、天气、光线、标志性物体、背景元素、整体环境、时代、题材、美术风格、图片视角等角度",
          uploadReference: "上传参考",
          generateImage: "生成图片",
          generatingWarning: "生图期间请勿关闭窗口，关闭将导致图片生成异常。",
          saveChanges: "保存更改",
          time: "时间",
          timePlaceholder: "如：清晨,正午,傍晚,夜晚...",
          weather: "天气",
          weatherPlaceholder: "如：晴朗,阴天,小雨,大雨,薄雾...",
          light: "光线",
          lightPlaceholder: "如：日光,暖光,月光,烛光,逆光...",
          imageCount: "图片数量",
          imageCountValue: "{count}张",
          startGenerate: "点击开始生成",
          calculating: "计算中",
          records: "生图记录",
          recordsHint: "选中记录中的图片后，点击保存，应用该图片。",
          generationFailed: "图片生成失败",
          failed: "生成失败",
          noRecords: "暂无记录",
          saveSettings: "保存设置",
          validation: {
            name: "请输入场景名称",
            prompt: "请输入提示词",
            model: "请选择模型",
            ratio: "请选择比例",
            resolution: "请选择分辨率",
            style: "请选择风格",
          },
          messages: {
            singleFileOnly:
              "只能上传一个文件，如有需要请删除上一个文件再进行上传",
            loginExpired: "登录状态已失效，请重新登录",
            uploadFailed: "上传失败",
            invalidFormat: "上传的文件格式不正确",
            fileTooLarge: "上传图片大小不能超过 10MB",
            missingImageId: "缺少图片记录ID",
            deleteConfirm: "确定删除这个图片吗？",
            deleteSuccess: "删除成功",
            pointsFailed: "获取消耗积分失败",
            operationFailed: "操作失败",
            saveFailed: "保存失败",
            selectCompletedBeforeSave: "请先选择已生成完成的图片再保存",
            uploadReference: "请上传参考图",
          },
        },
      },
      props: {
        list: "道具列表",
        more: "更多道具",
        batchTitle: "批量生成道具",
        searchPlaceholder: "搜索道具名",
        empty: "暂无道具",
        emptyTip: "点击下方按钮创建你的第一个道具",
        emptySearch: "未找到匹配道具",
        emptySearchTip: "尝试其他关键词搜索",
        create: "创建道具",
        deleteConfirm: "确定删除这个道具吗？",
        selectBatchWarning: "请先勾选要批量生成的道具",
        dialog: {
          createTitle: "创建道具",
          editTitle: "编辑道具",
          closeTip: "关闭窗口不会中断进行中的任务",
          close: "关闭",
          name: "道具名",
          namePlaceholder: "请输入",
          select: "请选择",
          generationMode: "生成方式",
          generateByModel: "通过模型生图",
          uploadImage: "自己上传图片",
          addImage: "添加图片",
          formatHint: "支持 PNG、JPG、JPEG、BMP，最大 10MB",
          model: "选择模型",
          ratio: "比例",
          resolution: "分辨率",
          style: "风格",
          prompt: "提示词",
          promptPlaceholder: "请描述你想生成的道具",
          uploadReference: "上传参考",
          generateImage: "生成图片",
          generatingWarning: "生图期间请勿关闭窗口，关闭将导致图片生成异常。",
          saveChanges: "保存更改",
          imageCount: "图片数量",
          imageCountValue: "{count}张",
          startGenerate: "点击开始生成",
          calculating: "计算中",
          records: "生图记录",
          recordsHint: "选中记录中的图片后，点击保存，应用该图片。",
          generationFailed: "图片生成失败",
          failed: "生成失败",
          noRecords: "暂无记录",
          saveSettings: "保存设置",
          validation: {
            name: "请输入道具名",
            prompt: "请输入提示词",
            model: "请选择模型",
            ratio: "请选择比例",
            resolution: "请选择分辨率",
            style: "请选择风格",
          },
          messages: {
            singleFileOnly:
              "只能上传一个文件，如有需要请删除上一个文件再进行上传",
            loginExpired: "登录状态已失效，请重新登录",
            uploadFailed: "上传失败",
            invalidFormat: "上传的文件格式不正确",
            fileTooLarge: "上传图片大小不能超过 10MB",
            missingImageId: "缺少图片记录ID",
            deleteConfirm: "确定删除这个图片吗？",
            deleteSuccess: "删除成功",
            pointsFailed: "获取消耗积分失败",
            operationFailed: "操作失败",
            saveFailed: "保存失败",
            selectCompletedBeforeSave: "请先选择已生成完成的图片再保存",
            uploadReference: "请上传参考图",
          },
        },
      },
      review: {
        title: "仿真人审核",
        notSubmitted: "未提交仿真人审核",
        reviewing: "平台仿真人审核中",
        rejected: "平台仿真人审核未通过",
        approved: "平台仿真人审核通过",
        notReviewed: "未审核",
        reviewingShort: "审核中",
        failed: "审核失败",
        approvedShort: "审核通过",
        noError: "暂无错误信息",
        confirmTitle: "确认提交审核？",
        confirmMessage:
          "提交后，当前数据将进入待审核状态，无法再次编辑，直到管理员审核通过或打回",
        approveTitle: "确定通过",
        approveMessage: "是否通过当前数据？",
      },
      materials: {
        list: "素材列表",
        upload: "上传素材",
        categoriesLabel: "素材分类",
        preview: "预览素材 {name}",
        categories: {
          all: "全部",
          character: "人物",
          scene: "场景",
          object: "道具",
          audio: "音效",
          other: "其他",
        },
        dialog: {
          name: "素材名称",
          namePlaceholder: "请输入素材名称",
          category: "素材分类",
          categoryPlaceholder: "请选择素材分类",
          file: "上传文件",
          fileRequired: "请选择上传文件",
          dragHere: "将文件拖到此处，或",
          clickSelect: "点击选择",
          editTitle: "编辑素材",
          add: "添加素材",
        },
        validation: {
          fileInvalid: "文件不符合上传要求",
          uploadFailedReselect: "文件上传失败，请重新选择文件",
          waitForUpload: "文件上传完成后才能添加素材",
          unsupportedType: "仅支持上传图片、视频或音频素材",
          imageFormat:
            "图片格式仅支持 jpeg、png、webp、bmp、tiff、gif、heic/heif",
          videoFormat: "视频格式仅支持 mp4、mov",
          audioFormat: "音频格式仅支持 wav、mp3",
          formatUnsupported: "文件格式不支持",
          imageSize: "图片大小需小于 30 MB",
          videoSize: "视频大小不能超过 50 MB",
          audioSize: "音频大小不能超过 15 MB",
          sizeExceeded: "文件大小超出限制",
          videoDurationUnreadable: "无法读取视频时长",
          audioDurationUnreadable: "无法读取音频时长",
          videoDurationRange: "视频时长需在 {min} 到 {max} 秒之间",
          audioDurationRange: "音频时长需在 {min} 到 {max} 秒之间",
          videoSizeUnreadable: "无法读取视频尺寸",
          imageSizeUnreadable: "无法读取图片尺寸",
          videoSideRange: "视频宽高需在 {min} 到 {max} px 之间",
          imageSideRange: "图片宽高需大于 {min} px 且小于 {max} px",
          videoRatioRange: "视频宽高比需在 {min} 到 {max} 之间",
          imageRatioRange: "图片宽高比需大于 {min} 且小于 {max}",
          videoResolution: "视频分辨率仅支持 480p、720p、1080p",
          videoPixels: "视频总像素数需在 {min} 到 {max} 之间",
          videoFpsUnreadable: "无法读取视频帧率",
          videoFpsRange: "视频帧率需在 {min} 到 {max} FPS 之间",
          videoInfoUnreadable: "无法读取视频信息",
          audioInfoUnreadable: "无法读取音频信息",
          credentialFailed: "获取上传凭证失败",
          saveUploadInfoFailed: "保存上传文件信息失败",
          credentialIncomplete: "上传凭证缺少必要字段",
          uploadFailed: "上传失败",
        },
        deleteConfirm: "确定删除这个素材吗？",
        messages: {
          listFailed: "素材列表获取失败",
          scopeMissing: "缺少素材归属信息",
          urlMissing: "缺少素材文件地址",
          idMissing: "缺少素材 ID",
          saveFailed: "素材保存失败",
          added: "添加成功",
          deleteFailed: "删除失败",
        },
      },
    },
    units: {
      currency: "元",
      episode: "集",
      second: "秒",
    },
    projects: {
      title: "我的项目",
      searchPlaceholder: "搜索项目名称",
      empty: "暂无项目",
      emptyTip: "点击下方按钮创建你的第一个 AI 漫剧项目",
      noMatch: "未找到匹配项目",
      tryAnotherKeyword: "尝试其他关键词搜索",
      create: "创建项目",
      add: "添加项目",
      actions: {
        statistics: "资产统计",
        details: "项目详情",
        edit: "编辑项目",
        delete: "删除项目",
        addMember: "添加成员",
      },
      statistics: {
        title: "资产统计",
        roles: "角色图片数",
        scenes: "场景图片数",
        props: "道具图片数",
      },
      details: {
        title: "项目详情",
        creator: "创建者账户",
      },
      form: {
        name: "项目名称",
        namePlaceholder: "请输入项目名称",
        budget: "项目预算",
        budgetPlaceholder: "请输入项目预算",
        episodes: "集数",
        episodesPlaceholder: "请输入集数",
        episodeDuration: "每集时长",
        durationPlaceholder: "请输入每集时长",
        description: "项目说明",
        descriptionPlaceholder: "请填写项目说明",
      },
      deleteConfirm: {
        message: "确定删除这个项目吗？删除后不可恢复。",
        confirm: "确定删除",
      },
    },
    management: {
      nav: {
        clips: "片段管理",
        roles: "角色管理",
        scenes: "场景管理",
        props: "道具管理",
        materials: "素材管理",
      },
      clips: {
        searchPlaceholder: "搜索片段名称",
        empty: "暂无片段",
        emptyTip: "点击下方按钮创建你的第一个片段",
        noMatch: "未找到匹配片段",
        create: "新建片段",
        createDialog: "创建片段",
        edit: "编辑片段",
        delete: "删除片段",
        videoStatistics: "视频统计",
        storyboardVideos: "分镜生视频",
        episodeTitle: "集数 Ep{name}",
        name: "片段名称",
        namePlaceholder: "请输入片段名称",
        description: "片段说明",
        descriptionPlaceholder: "请填写片段说明",
        deleteConfirm: {
          message: "确定删除这个片段吗？删除后不可恢复。",
          confirm: "确定删除",
        },
      },
    },
    members: {
      settings: "成员设置",
      usernamePlaceholder: "请输入用户名",
      count: "项目成员：{count}人",
      user: "用户",
      username: "用户名",
      role: "角色",
      selectMember: "请选择要分配的成员",
    },
    returnData: {
      title: "打回数据",
      reason: "打回原因",
      placeholder: "请输入打回原因，Ctrl + V 粘贴图片",
      imageTooLarge: "图片不能超过 5MB",
    },
    review: {
      submit: "提交仿真人审核",
      refresh: "刷新审核状态",
      hide: "隐藏审核状态",
      show: "展示审核状态",
      submitSuccess: "提交仿真人审核成功",
    },
    validation: {
      projectStatus: "请选择项目状态",
      number: "请输入数字",
      maxDigits: "最多输入 10 位数字",
      positiveInteger: "请输入大于 0 的正整数",
      projectNameRequired: "项目名称不能为空",
      length2To20: "长度 2-20 个字符",
    },
    permissions: {
      noCreate: "没有新增权限",
      notOwner: "你不是该数据负责人",
      noOperation: "没有操作权限",
    },
    messages: {
      created: "创建成功",
      updated: "修改成功",
      deleted: "删除成功",
      assigned: "分配成功",
      operationSuccess: "操作成功",
      operationFailed: "操作失败",
      uploadFailed: "上传失败",
    },
  },
  scriptCreation: {
    insufficientPoints: {
      coin: "币",
      title: "积分不足",
      description: "生成剧本需要消耗积分，您当前的积分余额不足。",
      required: "/ 需要 {value}",
      deficit: "缺少 {value} 积分",
      recharge: "去充值",
      refreshTip: "充值完成后请刷新页面",
    },
    common: {
      back: "返回",
      cancel: "取消",
      loading: "加载中",
      loadingDots: "加载中...",
      script: "剧本",
      outline: "大纲",
      scriptOutline: "剧本大纲",
      notSelected: "未选择",
      notFilled: "未填写",
      custom: "自定义",
      unknown: "未知",
      listSeparator: "、",
      episodeUnit: "集",
      minuteUnit: "分钟",
      episodeCount: "{count}集",
      durationMinutes: "{count}分钟",
    },
    workbench: {
      title: "工作台",
      subtitle: "欢迎回来，开始你的创作之旅",
      startTitle: "开始创作",
      startDesc: "创建新的剧本项目",
      scriptsTitle: "我的剧本",
      projectCount: "{count}个项目",
    },
    list: {
      title: "我的剧本",
      searchPlaceholder: "搜索剧本名称...",
      newScript: "新建剧本",
      loading: "剧本列表加载中...",
      empty: "暂无剧本，点击右上角“新建剧本”开始创作",
      view: "查看",
      download: "下载",
      delete: "删除",
      deleting: "删除中",
    },
    saveSuccess: {
      saved: "保存成功",
      title: "保存成功！",
      desc: "您的剧本已成功保存到剧本库",
      backWorkbench: "返回工作台",
      createComic: "一键创作漫剧",
      viewScripts: "查看我的剧本",
    },
    steps: {
      story: { name: "一句话故事", desc: "故事起点" },
      genre: { name: "题材配置", desc: "故事方向" },
      params: { name: "参数配置", desc: "画面参数设定" },
      outline: { name: "剧本大纲", desc: "预览与确认" },
    },
    summary: {
      title: "创作设定",
      note: "AI 将根据这些配置调整剧本节奏、人物关系和画面描述。",
      story: "一句话故事",
      genre: "题材",
      subGenre: "子题材",
      creationStyle: "创作风格",
      keywords: "关键词",
      episodeCount: "集数",
      duration: "单集时长",
      ratio: "画面比例",
      resolution: "分辨率",
      videoStyle: "视频风格",
    },
    story: {
      label: "一句话故事（AI将分析你的故事推荐题材风格，不填也能继续）",
      placeholder:
        "描述你的故事核心设定、冲突和亮点。例如：现代职场女性意外穿越到古代，与冷面王爷相识相爱的故事。",
    },
    genre: {
      selectGenre: "选择题材",
      customGenreLabel: "自定义题材（不超过20字）",
      customGenrePlaceholder: "输入题材名称...",
      selectSubGenre: "选择子题材",
      multiSelectHint: "可多选，用中文逗号分隔多个标签",
      loadingSubGenres: "正在获取子题材...",
      customSubGenrePlaceholder: "+ 自定义子题材",
      keywordTags: "关键词标签",
      loadingKeywords: "正在获取关键词...",
      customKeywordPlaceholder: "+ 添加自定义关键词",
      creationStyle: "创作风格",
    },
    params: {
      episodeTitle: "集数设置",
      episodeDesc: "设置剧本总集数（单次最多 {count} 集）",
      durationTitle: "单集时长",
      durationDesc: "每集视频时长",
      ratioTitle: "画面比例",
      resolutionTitle: "分辨率",
      videoStyleTitle: "视频风格",
      videoStyleHint: "鼠标悬浮查看预览",
      modelTitle: "选择大模型",
    },
    outline: {
      summary: "剧本概括",
      worldview: "世界观设定",
      theme: "核心主题",
      summaryNote: "AI 根据您的一句话故事生成了大纲，您可以直接编辑修改。",
      editNameAria: "编辑剧本名字",
    },
    detail: {
      backAria: "返回",
      model: "模型",
      parameters: "参数",
      messages: {
        noOutlineContent: "暂无大纲内容",
        episodeSaveFailed: "分集保存失败",
        episodeDetailSaveFailed: "分集详细内容保存失败",
        characterSaveFailed: "角色保存失败",
        characterReferencedCannotEdit: "该人物已被分集概括引用，不能修改",
        characterReferencedCannotDelete: "该人物已被分集概括引用，不能删除",
        characterCannotDelete: "该人物不能删除",
        characterReferencedCannotRename: "该人物已被分集概括引用，不能修改名字",
        characterNameExists: "人物名称已存在",
        characterDeleteFailed: "角色删除失败",
        newCharacterName: "新人物{n}",
        rolePending: "待补充",
        characterDescPlaceholderDefault: "请补充人物设定。",
        newAvatar: "新",
        personFallback: "人",
        goalLabel: "目标：",
        storyFunctionLabel: "剧情作用：",
        roleTypePerson: "人物",
        protagonistTeam: "主角团队",
        mainCharacter: "主角",
        partner: "伙伴",
        indoor: "室内",
        infoHotspot: "信息爆点",
        expectationHook: "期待式钩子",
        episodeListFailed: "分集列表获取失败",
        episodeDetailFailed: "分集详情获取失败",
        episodeDetailTimeout: "分集详细内容生成超时，请稍后刷新查看",
        episodeIdMissing: "分集ID不存在，无法生成详细内容",
        selectTextModel: "请先选择文本模型",
        mockEpisodePlot:
          "{description} 本集围绕{people}展开，通过冲突推进人物关系，并在结尾设置新的悬念。",
        mockExplorerCommandBridge: "探索者号指挥舱",
        mockMainConsoleArea: "主控台前",
        mockEpisodeScript:
          "第1场 · 室内 · 探索者号指挥舱\n时间：深夜\n\n▽警报灯在舱壁上缓慢闪烁，蓝色光芒在角色脸上流动。\n\n◆{protagonist}\n> 【冷】“全员注意，进入未知区域。各部门报告状况。”\n\n▽数据流如同瀑布般从屏幕坠落，新的信号坐标被锁定。\n\n◆{partner}\n> 【紧】“相似度达到98.7%，建议立即派遣调查队。”\n\n▽主角沉默片刻，目光落在不断跳动的坐标上。\n\n◆{protagonist}\n> 【忍】“准备登陆程序。十分钟后在发射舱集合。”\n\n▽镜头掠过舷窗，未知星体的轮廓在黑暗中逐渐清晰。\n\n本集结束。",
        mockHotspotDescription:
          "在普通调查中突然发现高相似度信号，突出未知的奇异感与看点。",
        mockHookDescription:
          "类地行星上究竟存在什么？调查队登陆后将面对怎样的未知？",
        mockEpisodeSummary:
          "本集以任务开启和异常信号为核心，快速建立悬念，并为后续调查队登陆行动铺垫。",
      },
      nav: {
        all: "全部",
        outline: "大纲",
        characters: "人物设定",
        episodes: "分集概括",
        episodeDetails: "分集详情",
      },
      noEpisodeDetails: "暂无详细内容",
      episode: "第{n}集",
      storyOutline: "故事大纲",
      characters: "人物设定",
      addCharacter: "新增人物",
      characterNamePlaceholder: "请输入人物名",
      characterRolePlaceholder: "请输入人物身份",
      characterDescPlaceholder: "请输入人物设定",
      episodeSummary: "分集概括",
      includedCharacters: "包含人物：",
      addEpisodeCharacter: "添加人物",
      generationFailed: "生成失败",
      detailGenerated: "已生成本集详细内容",
      generating: "生成中...",
      regenerate: "重新生成",
      generateEpisode: "生成本集剧本",
      episodeDetail: {
        plot: "本集详细剧情",
        plotHint: "300-500字，详细描述本集发生的故事",
        cast: "出场人物",
        scenes: "场景列表",
        script: "详细剧本",
        scriptHint:
          "包含场景划分、画面/镜头描述、人物动作、角色对白（带情绪标签）",
        scriptPlaceholder: "请输入详细剧本",
        copy: "复制",
        copySuccess: "剧本文字已复制",
        copyFailed: "复制失败",
        highlights: "爆点强化建议",
        hotspot: "爆点",
        hook: "追更钩子设计",
        summary: "创作总结",
        generationStarted: "已开始生成分集详细内容",
        regenerationStarted: "已开始重新生成分集详细内容",
        generateFailed: "分集详细内容生成失败",
      },
      scriptTitleFallback: "剧本详情",
      scriptGenre: "剧本题材",
      customValue: "自定义",
      defaultValue: "默认",
      episodeCountValue: "{n}集",
      durationValue: "{n}分钟",
      generatedHint: "剧本内容已生成，您可查看剧本内容或编辑。",
      saveScript: "保存剧本",
      exporting: "导出中...",
      exportTxt: "导出TXT",
    },
    generating: {
      scriptTitle: "AI正在生成剧本...",
      waitTip: "预计需要 3-5 分钟，请稍候",
    },
    wizard: {
      next: "下一步",
      generateOutline: "开始生成大纲 {count}",
      regenerate: "重新生成",
      generateScript: "确认并生成剧本 {count}集",
    },
    headers: {
      story: "故事起点",
      genre: "题材配置",
      params: "参数配置",
    },
    footerHints: {
      story: "您的一句话故事，将是AI创作的核心灵感。",
      genre: "AI将基于您的题材选择辅助创作，您也可随时自定义调整。",
      params:
        "AI将根据画面比例、风格等参数，调整剧本的场景描述和节奏，以适配您的视频制作需求",
      outline: "AI根据您的一句故事生成了大纲，您可以直接编辑修改。",
    },
    validation: {
      maxChars: "输入内容不能超过{count}个字",
    },
    status: {
      initializingEngine: "正在初始化创作引擎...",
      parsingGenre: "正在解析题材：{genre}...",
      buildingStory: "正在构建故事框架...",
      generatingWorldview: "正在生成世界观设定...",
      writingSummary: "正在撰写剧本概括...",
      almostDone: "即将完成...",
      organizingOutline: "正在整理大纲内容...",
      outlineDone: "大纲生成完成",
      generatingOutline: "AI正在生成大纲...",
      generatingCharacters: "正在生成角色设定...",
      writingEpisodes: "正在撰写分集大纲...",
      enrichingDetails: "正在丰富剧情细节...",
      scriptDone: "剧本生成完成",
      organizingScript: "正在整理剧本分集内容...",
      viewingOutline: "正在查看剧本大纲...",
    },
    messages: {
      outlineSaveFailed: "大纲保存失败",
      genreListFailed: "题材列表获取失败",
      subGenreListFailed: "子题材列表获取失败",
      keywordListFailed: "关键词列表获取失败",
      pointsNotEnough: "积分不足",
      pointsCheckFailed: "积分校验失败",
      outlineTaskCreateFailed: "大纲生成任务创建失败",
      outlineGenerateFailed: "大纲生成失败",
      projectMissingRegenerate: "剧本项目ID不存在，无法重新生成",
      outlineStatusFailed: "大纲生成状态查询失败",
      outlineResultEmpty: "大纲生成结果为空",
      outlineDetailFailed: "大纲详情获取失败",
      cancelOutlineFailed: "取消生成大纲失败",
      projectMissingScript: "剧本项目ID不存在，无法生成剧本",
      scriptTaskCreateFailed: "剧本分集生成任务创建失败",
      scriptGenerateFailed: "剧本分集生成失败",
      scriptStatusFailed: "剧本分集生成状态查询失败",
      aiUnavailable: "AI 服务暂时不可用，请稍后重试。",
      cancelScriptFailed: "取消生成剧本分集失败",
      scriptDetailFailed: "剧本详情获取失败",
      scriptResultEmpty: "剧本分集生成结果为空",
      outlineConfirmed: "剧本大纲已确认",
      featureComingSoon: "功能开发中，敬请期待！",
      scriptListFailed: "剧本列表获取失败",
      scriptIdMissingView: "剧本ID不存在，无法查看详情",
      noDownloadableScript: "该条记录暂无可下载剧本",
      deleteConfirm: "确定删除这个剧本吗？删除后不可恢复。",
      deleteTitle: "提示",
      confirmDelete: "确定删除",
      scriptIdMissingDelete: "剧本ID不存在，无法删除",
      deleteSuccess: "删除成功",
      deleteFailed: "删除失败",
      downloadFailed: "剧本下载失败",
      scriptIdMissingExport: "剧本ID不存在，无法导出",
    },
    presets: {
      genres: {
        romance: { name: "爱情" },
        suspense: { name: "悬疑" },
        fantasy: { name: "奇幻" },
        scifi: { name: "科幻" },
        historical: { name: "古装" },
        comedy: { name: "喜剧" },
        action: { name: "动作" },
        horror: { name: "恐怖" },
        school: { name: "校园" },
        career: { name: "职场" },
        custom: { name: "自定义" },
      },
      tags: {
        timeTravel: "穿越",
        urban: "都市",
        childhoodSweethearts: "青梅竹马",
        marriageFirst: "先婚后爱",
        misunderstanding: "误会",
        reunion: "重逢",
        growth: "成长",
        mutualCommitment: "双向奔赴",
        criminalInvestigation: "刑侦",
        lockedRoom: "密室",
        psychological: "心理",
        urbanLegend: "都市怪谈",
        truth: "真相",
        twist: "反转",
        evidence: "证据",
        tracking: "追踪",
        isekai: "异世界",
        magic: "魔法",
        cultivation: "修仙",
        superpower: "超能力",
        adventure: "冒险",
        awakening: "觉醒",
        destiny: "宿命",
        secretRealm: "秘境",
        interstellar: "星际",
        ai: "AI",
        timeLoop: "时间循环",
        apocalypse: "末日",
        civilization: "文明",
        exploration: "探索",
        crisis: "危机",
        restart: "重启",
        palace: "宫廷",
        martialWorld: "江湖",
        powerStruggle: "权谋",
        court: "朝堂",
        identity: "身世",
        revenge: "复仇",
        alliance: "盟约",
        workplace: "职场",
        family: "家庭",
        antiTrope: "反套路",
        accidentalChaos: "误打误撞",
        hilarious: "爆笑",
        contrast: "反差",
        comeback: "逆袭",
        agent: "特工",
        hotBlooded: "热血",
        racing: "竞速",
        combat: "格斗",
        chase: "追逐",
        confrontation: "对抗",
        rescue: "救援",
        team: "团队",
        supernatural: "灵异",
        folklore: "民俗",
        thriller: "惊悚",
        denseForest: "密林",
        curse: "诅咒",
        taboo: "禁忌",
        escape: "逃生",
        unknown: "未知",
        youth: "青春",
        club: "社团",
        graduation: "毕业",
        friendship: "友情",
        dream: "梦想",
        crush: "心动",
        regret: "遗憾",
        startup: "创业",
        businessWar: "商战",
        legal: "律政",
        medical: "医疗",
        competition: "竞争",
        choice: "抉择",
        breakthrough: "突破",
        partner: "伙伴",
        originalGenre: "原创题材",
        hybridGenre: "混合类型",
        freeCreation: "自由创作",
        differentiation: "差异化",
      },
      styles: {
        seriousRealistic: "严肃写实",
        lightComedy: "轻松搞笑",
        mysteryHumor: "悬疑幽默",
        hotBlooded: "热血燃向",
        healingWarm: "治愈温暖",
        darkOppressive: "暗黑压抑",
        literaryFresh: "文艺清新",
        epicDrama: "剧情宏大",
        powerFantasy: "无脑爽文",
      },
      videoStyles: {
        chinese3d: "3D国漫",
        japaneseAnime: "日系动漫",
        realistic: "写实风",
        inkWash: "水墨风",
        pixel: "像素风",
        cyberpunk: "赛博朋克",
        minimalLine: "极简线条",
      },
    },
  },
  projectLibrary: {
    personal: "个人项目",
    groups: "项目组",
    groupsWithCount: "项目组 ({count})",
    createGroup: "新建项目组",
    createGroupNoPermission: "仅超级管理员、管理员和子管理员可以创建项目组",
    emptyNoGroups: "暂无项目组",
    emptyNoGroupsHint: "请联系管理员创建或邀请你加入",
    members: "{count} 名成员",
    inviteOpen: "邀请链接开",
    inviteClosed: "未开启邀请",
    inviteDisconnected: "邀请链接已断开",
    available: "项目可用 {used} / {total}",
    quotaFixed: "固定额度 · {n}/人",
    quotaGift: "赠送额度 · {n}/人",
    quotaExclusive: "独享额度 · {n}/人",
    quotaUnlimited: "不限额",
    statusRunning: "进行中",
    statusPaused: "暂停",
    statusFilterPaused: "已暂停",
    statusFinished: "已完毕",
    statusClosed: "已关闭",
    fetchListFailed: "获取项目组列表失败",
    noMatch: "未找到匹配项目组",
    tryAnotherKeyword: "尝试其他关键词搜索",
    create: {
      titleCanvas: "新建泫宗画布项目组",
      subtitle: "一次完成项目设置、成员选择与邀请配置",
      close: "关闭创建项目组",
      stepLabel: "步骤 {current}/3 · {name}",
      step1: "基本信息与额度",
      step1Desc: "设置项目名称、积分与成员通用额度",
      step2: "添加学校学生",
      step3: "邀请设置",
      name: "项目组名称",
      namePlaceholder: "请输入项目组名称",
      allocate: "划入项目积分",
      allocatePlaceholder: "请输入划入积分",
      allocateHint: "优先使用订阅积分",
      creatorAvailable: "创建者可用积分",
      quotaMode: "成员额度模式",
      quotaPerMember: "每人项目总额度",
      quotaPerMemberPlaceholder: "请输入每人额度",
      modeFixed: "固定额度 · 全员一致",
      modeUnlimited: "不限额 · 共用项目余额",
      step1Tip:
        "项目积分从你的可用积分中扣除，仅限当前{scene}项目组使用，不足时不会自动使用成员个人积分。",
      sceneCanvas: "泫宗画布",
      addMembers: "添加成员",
      addMembersTip: "可按组织批量勾选，创建后统一应用额度",
      searchStudent: "搜索学校学生",
      searchStudentPlaceholder: "昵称或手机号",
      searchMemberPlaceholder: "搜索姓名、手机号、角色或账号层级",
      colName: "姓名",
      colLevel: "账号层级",
      colPhone: "手机号",
      colRole: "角色",
      allMembers: "全部成员 ({count}人)",
      allMembersLabel: "全部成员",
      allMembersCount: "{count}人",
      selectSubtree: "全部选择",
      deselectSubtree: "取消全选",
      selfLockedTip: "创建者默认加入，不可取消勾选",
      step2Tip:
        "可以添加学校里的任意学生。固定额度只做统一批量设置，不能单独修改某个成员。",
      generateLink: "创建完成后生成项目组加入链接",
      linkExpiry: "链接有效期",
      joinQuota: "加入后的通用额度",
      day1: "1天",
      day7: "7天",
      day30: "30天",
      pointsUnit: "积分/人",
      step3Tip:
        "若项目可分配积分不足，新成员仍可加入，但初始项目额度为 0；管理员补充项目积分后再统一批量设置。",
      prev: "上一步",
      next: "下一步",
      submit: "创建项目组",
      nameRequired: "请输入项目组名称",
      allocateRequired: "请输入划入项目积分",
      allocateExceed: "划入积分不能超过创建者可用积分",
      allocateInvalid: "划入积分须为大于等于 0 的整数",
      quotaRequired: "请输入每人项目总额度",
      quotaInvalid: "每人额度须为正整数",
      quotaExceed: "每人项目总额度不能超过创建者可用积分",
      success: "项目组已创建",
      failed: "创建项目组失败",
      noStudent: "未找到匹配成员",
      membersLoadFailed: "成员列表加载失败",
      pointsLoadFailed: "创建者可用积分加载失败",
      accountLevels: {
        admin: "管理员",
        subAdmin: "子管理员",
        member: "成员",
      },
    },
    workbench: {
      title: "项目组工作台",
      subtitle: "集中管理成员、项目积分和作品查看权限",
      backToList: "返回项目组列表",
      searchPlaceholder: "搜索项目组",
      createCanvas: "创建画布",
      // 头部刷新按钮：重拉额度卡和当前 Tab
      refresh: "刷新",
      topup: "调整积分",
      manageInvite: "管理邀请链接",
      creator: "创建者：{name} · {dept}",
      deptCanvas: "泫宗画布项目组",
      quotaFixedShort: "额度 {n}/人",
      quotaGiftShort: "赠送 {n}/人",
      quotaExclusiveShort: "独享 {n}/人",
      stats: {
        // 拆分卡左列：剩余可用
        available: "剩余可用积分",
        // 拆分卡右列：项目总额
        total: "项目积分总额",
        // 顶部合并卡：剩余 / 总额
        availableTotal: "剩余可用积分/项目积分总额",
        unifiedQuota: "统一额度",
        // 成员模式：总额度减去已消耗
        personalAvailable: "个人可用额度",
        // 统计卡右侧：当前登录成员额度，对应 currentMember.quotaLimit
        personalQuota: "个人总额度",
        unifiedPersonal: "统一额度/个人总额度",
        members: "项目成员",
        consumed: "项目累计消耗",
        // 统计卡右侧：当前登录成员消耗，对应 currentMember.usedIntegral
        personalConsumed: "个人累计消耗",
        consumedPersonal: "项目累计消耗/个人累计消耗",
        perPerson: "{n} / 人",
        // 统一额度列只展示数字，不再带「/人」
        perPersonCompact: "{n}",
      },
      // 问号说明：禁用按钮外仍能悬停
      helpAria: "{label}说明",
      tips: {
        available: "当前项目剩余可消耗积分。",
        total: "已划入项目的积分总额。",
        availableTotal: "当前项目剩余可消耗积分 / 已划入项目的积分总额。",
        unifiedQuota: "项目统一设置的成员额度。",
        personalAvailable: "当前成员在本项目中剩余可使用的额度。",
        personalQuota: "单个成员实际获得的额度。",
        unifiedPersonal: "前者为项目统一设置的成员额度，后者为单个成员实际获得的额度。",
        members: "当前已加入且尚未移除的成员数量。",
        consumed: "项目全部成员累计消耗。",
        personalConsumed: "单个成员在项目中的累计消耗。",
        consumedPersonal: "前者为项目全部成员累计消耗，后者为单个成员在项目中的累计消耗。",
        topup:
          "调整项目组积分总额：可从创建者可用积分中增加项目积分，也可扣减项目内未消耗积分并退回创建者账户；调整后的项目总积分不得低于已消耗积分。",
        batchQuota:
          "统一覆盖当前项目组全部成员的额度设置，可选择固定额度或不限额；固定额度时所有成员获得相同总额度，已消耗部分不受影响。",
        audit: "记录项目设置、成员管理、额度调整及邀请管理等关键操作。",
        status: "控制项目为进行中、暂停、已完毕或关闭；状态会影响成员是否可继续生产。",
        // 积分明细成员搜索：后端只按消耗类流水匹配名称
        searchMemberName: "仅支持搜索积分消耗类型的积分明细",
      },
      tabs: {
        members: "成员与额度",
        works: "成员作品",
        points: "积分明细",
        settings: "项目设置",
        // 创建者操作日志：审计流水 6–18
        audit: "操作日志",
        // 创建者 / 成员都有我的作品；成员另有我的积分明细 / 项目信息
        myWorks: "我的作品",
        myPoints: "我的积分明细",
        info: "项目信息",
      },
      membersHint: "可管理成员额度与使用状态；项目积分仅限当前项目组使用",
      addStudents: "添加成员",
      batchQuota: "批量设置额度",
      columns: {
        member: "成员",
        role: "身份",
        consumedQuota: "已消耗/总额度",
        works: "作品",
        status: "状态",
        actions: "操作",
        memberName: "成员名称",
        time: "时间",
        action: "操作",
        // 积分明细：操作右边展示接口 remark
        operateDetail: "操作明细",
        change: "积分变更",
        // 成员「我的积分明细」：变更列改成消耗
        consume: "消耗",
        type: "类型",
        // 创建者积分明细：与顶部统计卡「剩余可用积分」同一套口径
        balance: "剩余可用积分",
        // 成员「我的积分明细」：对齐个人额度卡
        remainingQuota: "剩余额度",
        model: "模型",
        resolution: "分辨率/清晰度",
        quantity: "时长/数量",
        // 操作日志：类型 / 内容 / 明细
        operateTime: "操作时间",
        operator: "操作对象",
        operateContent: "操作内容",
        operateType: "操作类型",
        detail: "明细",
      },
      roleMember: "成员",
      roleCreator: "创建者",
      worksCount: "{n} 个作品",
      statusNormal: "正常",
      statusDisabled: "已禁用",
      adjustPoints: "调整额度",
      disable: "禁用",
      restore: "恢复",
      viewWorks: "查看作品",
      remove: "移除",
      cannotRemoveCreator: "不能移除创建者",
      cannotDisableCreator: "不能禁用创建者",
      cannotAdjustCreator: "不能调整创建者额度",
      removeSuccess: "成员已移除",
      removeFailed: "移除成员失败",
      removeConfirm: {
        title: "确定要移除「{name}」吗？",
        message: "移除后该成员将失去项目组访问权限，已消耗积分不会退回。",
        confirm: "确定移除",
      },
      disableConfirm: {
        title: "确定要禁用「{name}」吗？",
        message: "禁用后该成员将无法继续在当前项目组生产。",
        confirm: "确定禁用",
      },
      restoreConfirm: {
        title: "确定要恢复「{name}」吗？",
        message: "恢复后该成员可继续在当前项目组生产。",
        confirm: "确定恢复",
      },
      worksHint: "创建者可编辑自己的画布，其他成员作品仅支持查看",
      myWorksHint: "仅展示我创建的作品，可进入编辑",
      memberWorksHint: "仅展示其他成员作品，只读查看",
      filterAll: "全部",
      filterEdit: "可编辑",
      filterView: "可查看",
      searchWork: "搜索画布/人员名称",
      searchWorkName: "搜索作品名称",
      searchMemberName: "搜索成员名称",
      allTypes: "全部类型",
      allTime: "全部时间",
      timeToday: "今天",
      timeWeek: "近 7 天",
      timeMonth: "近 30 天",
      startDate: "开始日期",
      endDate: "结束日期",
      rangeSeparator: "至",
      datePickerFormat: "yyyy/MM/dd",
      workTimeAria: "按创建时间筛选画布",
      selectTimeRange: "选择时间范围",
      datePlaceholder: "年 / 月 / 日",
      clearTimeRange: "清空",
      incompleteTimeRange: "请选择开始日期和结束日期",
      startAfterEnd: "开始日期不能大于结束日期",
      typeCanvas: "画布作品",
      typeStoryboard: "分镜作品",
      typeImage: "图片作品",
      createdAt: "创建于 {time}",
      workAuthorTime: "{name} · {time}",
      readOnlyView: "可查看",
      enterEdit: "可编辑",
      emptyWorks: "暂无成员作品",
      emptyMyWorks: "暂无作品",
      emptyGroups: "未找到匹配项目组",
      dash: "--",
      todayTime: "今天 {time}",
      justNow: "刚刚",
      settingsStatusTitle: "项目状态",
      settingsStatusHint: "设置项目组当前阶段；暂停后可重新恢复为进行中。",
      info: {
        groupName: "项目组名称",
        status: "项目状态",
        creator: "创建者",
        quotaMode: "额度模式",
        hint: "项目额度仅限当前项目使用。你可以编辑自己的作品，并以只读方式查看其他成员作品。",
      },
      statusRunningTitle: "进行中",
      statusRunningDesc: "默认状态，成员可以正常生产",
      statusPausedTitle: "暂停",
      statusPausedDesc: "暂时停止成员继续生产",
      statusFinishedTitle: "已完毕",
      statusFinishedDesc: "项目工作已完成，可继续查看内容",
      statusClosedTitle: "关闭项目",
      statusClosedDesc: "关闭生产并结束当前项目组",
      settingsSaved: "项目设置已更新",
      statusChanged: "项目状态已更换为「{status}」",
      statusClosedSuccess: "已关闭项目",
      statusChangeFailed: "项目状态更新失败",
      statusFinishedLocked: "当前项目组当前阶段已完毕,无法修改状态",
      statusFinishedActionLocked: "当前项目组已完毕，无法进行该操作",
      statusPausedActionLocked: "当前项目组已暂停，无法进行该操作",
      statusClosedLocked: "当前项目组当前阶段已关闭,无法修改状态",
      statusClosedActionLocked: "当前项目组已关闭，无法进行该操作",
      closeConfirm: {
        title: "确认关闭项目",
        subtitle: "此操作将改变项目组的生产状态",
        bodyLead: "关闭后成员将无法继续生产。",
        bodyFollow:
          "未消耗积分将按正式业务规则退回创建者账户，请确认是否关闭当前项目。",
        confirm: "确认关闭项目",
      },
      finishConfirm: {
        title: "确认标记为已完毕",
        subtitle: "此操作将改变项目组的生产状态",
        body: "标记为已完毕后将无法再切换项目状态，请确认工作已完成。",
        confirm: "确认标记为已完毕",
      },
      disableSuccess: "成员已禁用",
      restoreSuccess: "成员已恢复",
      disableFailed: "禁用成员失败",
      restoreFailed: "恢复成员失败",
      notFound: "未找到该项目组",
      fetchDetailFailed: "获取项目组详情失败",
      // 成员模式点画布 / 创建前发现已被禁用或移出
      memberAccessBlocked: {
        disabledTitle: "无法继续操作",
        disabledMessage: "你已被禁用，无法继续在当前项目组生产",
        removedTitle: "无法继续操作",
        removedMessage: "你已被移出项目组，无法继续访问当前项目组",
        confirm: "返回项目组列表",
      },
      fetchWorksFailed: "获取组内画布失败",
      fetchLedgerFailed: "获取积分明细失败",
      emptyLedger: "暂无数据",
      fetchAuditFailed: "获取操作日志失败",
      emptyAudit: "暂无数据",
      // 操作日志筛选 / 类型列分组
      audit: {
        settings: "项目设置",
        member: "成员管理",
        quota: "额度调整",
      },
      batch: {
        title: "批量设置成员额度",
        subtitle: "该设置将统一覆盖所有 {count} 名成员",
        quotaMode: "额度模式",
        quotaPerPerson: "每人项目积分总额度",
        hint: "总额度不能低于当前非管理员成员已消耗的最高积分。若成员已消耗 50 积分，总额度改为 200 后剩余 150。",
        confirm: "确认批量设置",
        quotaBelowConsumed: "每人项目总额度不能低于当前非管理员成员已消耗的最高积分（{n}）",
        quotaExceed: "每人项目总额度不能超过创建者总积分+项目总积分",
        success: "成员额度已批量更新",
        failed: "批量设置成员额度失败",
      },
      topupDialog: {
        title: "调整项目积分",
        desc: "可从创建者账户划入积分，也可将未消耗积分退回",
        opType: "操作类型",
        opAdd: "增加积分",
        opReduce: "退回积分",
        creatorAvailable: "创建者可用积分",
        projectTotal: "项目当前总积分",
        projectConsumed: "项目已消耗积分",
        projectRemaining: "项目当前剩余积分",
        amount: "本次调整数量",
        afterTotal: "调整后项目总积分",
        afterRemaining: "调整后剩余积分",
        confirm: "确认调整",
        success: "项目积分已补充",
        successReduce: "未消耗积分已退回创建者账户",
        failed: "项目积分划入失败",
        failedReduce: "项目积分退回失败",
        invalid: "调整数量须为正整数",
        exceed: "增加积分不能超过创建者可用积分",
        exceedReduce: "退回积分不能超过项目当前剩余积分",
      },
      invite: {
        title: "项目组邀请链接",
        desc: "链接有效，可直接复制分享",
        descExpired: "链接已过期，请重新生成后再分享",
        descExpiryChanged: "有效期已更改，需重新生成后再分享",
        quota: "通用额度",
        quotaValue: "{n} 积分/人",
        expiry: "有效期",
        hour24: "24小时",
        hour72: "72小时",
        link: "邀请链接",
        hint: "链接继承项目组的统一额度模式。项目积分不足时，新成员仍可加入。",
        preview: "预览加入流程",
        copy: "复制链接",
        regenerateAndCopy: "重新生成链接并复制",
        copied: "邀请链接已复制",
        regeneratedCopied: "新邀请链接已生成并复制",
        copyFailed: "复制失败",
        generateFailed: "邀请链接生成失败",
        loadFailed: "邀请链接查询失败",
      },
      join: {
        title: "{name} 的加入邀请",
        subtitle: "业务员视角，点击后加入项目组",
        projectType: "项目类型",
        joinQuota: "加入后额度",
        quotaValue: "{n} 积分",
        group: "所属项目组",
        permission: "作品权限",
        permissionValue: "自己的可编辑，他人只读",
        pointsHint:
          "项目积分只能在该项目组内使用，退出项目组或进入其他项目时不能使用。",
        confirm: "确认加入项目组",
        success: "已加入项目组",
      },
      invitePage: {
        badge: "项目邀请",
        title: "邀请你加入项目组",
        summary:
          "{enterprise}的 {inviter} 邀请你加入项目组「{project}」。请于{deadline}前确认，逾期后邀请链接将失效。",
        enterprise: "企业名称",
        inviter: "邀请人",
        projectName: "项目组名称",
        deadline: "截止时间",
        deadlineLocal: "{date} {time}",
        deadlineEn: "{time} on {date}",
        agreeHint:
          "同意后，你将成为该项目组成员，并使用项目组为你分配的额度进行创作。",
        agree: "同意加入",
        enter: "进入项目组",
        invalid: "邀请链接已失效，请联系邀请人重新获取",
        alreadyMember: "你已经是该项目组成员，无需重复加入",
        joinSuccess: "已加入项目组",
        joinFailed: "加入项目组失败，请稍后重试",
        loadFailed: "邀请确认页信息加载失败，请稍后重试",
        empty: "—",
      },
      canvasDialog: {
        title: "创建项目画布",
        desc: "画布将归属当前项目组，积分仅从项目组额度中消耗",
        name: "画布名称",
        defaultName: "未命名画布",
        hint: "创建后将生成空白画布。创建者可以编辑；管理员、子管理员及项目内其他成员只读查看。",
        confirm: "确认创建画布",
        success: "画布已创建",
        failed: "创建画布失败",
        nameRequired: "请输入画布名称",
      },
      renameDialog: {
        title: "修改项目组名称",
        desc: "保存后侧栏和工作台将同步展示新名称",
        name: "项目组名称",
        namePlaceholder: "请输入项目组名称",
        confirm: "保存名称",
        success: "项目组名称已更新",
        failed: "修改项目组名称失败",
        nameRequired: "请输入项目组名称",
        aria: "修改项目组名称",
      },
      addStudent: {
        title: "添加成员",
        tip: "可按组织批量勾选，添加后统一应用额度",
        confirm: "确认添加",
        success: "成员已加入项目组",
        successWithRemove: "成员列表已更新",
        noneSelected: "请选择要添加的成员",
        failed: "添加成员失败",
        removeConfirm: {
          title: "确定移除已取消勾选的成员吗？",
          message:
            "共 {count} 人将被移出项目组，移除后将失去访问权限，已消耗积分不会退回。",
          confirm: "确定移除",
        },
      },
      adjust: {
        title: "调整成员额度",
        subtitle: "{name} · 仅调整当前项目组内可用额度",
        member: "成员",
        current: "已消耗 / 总额度",
        newQuota: "新的总额度",
        hint: "总额度不能低于该成员已消耗积分。若成员已消耗 50 积分，总额度改为 200 后剩余 150。",
        opType: "操作类型",
        opAdd: "添加额度",
        opReduce: "减少额度",
        amount: "调整数量",
        consumed: "当前已消耗",
        currentTotal: "当前总额度",
        afterTotal: "调整后总额度：{n} 积分",
        confirm: "确认调整",
        success: "成员额度已更新",
        failed: "成员额度调整失败",
        invalid: "总额度须为非负整数",
        resultInvalid: "调整后总额度不能为负数",
        belowConsumed: "调整后总额度不能小于成员已消耗额度",
        exceed: "调整额度不能超过创建者总积分+项目总积分",
      },
      ledger: {
        transferIn: "项目积分划入",
        transferOut: "项目积分退回",
        canvasGenerate: "画布生成",
        storyboardGenerate: "分镜生成",
        credit: "项目入账",
        refund: "项目退回",
        consume: "成员消耗",
        modelTumeng: "图梦 3.0",
        res2k: "2K / 高清",
        quantityImages: "{n} 张",
        durationSeconds: "{n}秒",
      },
    },
  },
  visionCanvas: {
    title: "我的画布",
    subtitle: "该项目画布中的项目组、成员、积分将独立管理",
    createTime: "创建时间",
    searchPlaceholder: "搜索项目名称",
    createProject: "新建项目",
    loading: "加载中...",
    empty: "暂无画布项目",
    emptyTip: "创建你的第一个画布项目开始创作",
    emptyNotFound: "未找到匹配项目",
    emptyHint: "尝试其他关键词搜索",
    open: "打开",
    rename: "重命名",
    delete: "删除",
    enterProject: "进入项目",
    editMode: "可编辑",
    viewMode: "仅查看",
    filterAll: "全部",
    filterView: "可查看",
    emptyFilterHint: "尝试切换筛选条件",
    createTimeLabel: "创建时间：{date}",
    creatorLabel: "创作者：{name}",
    untitled: "未命名",
    dateFormat: "{year}年{month}月{day}日",
    fetchListFailed: "获取项目列表失败",
    renameSuccess: "重命名成功",
    operationFailed: "操作失败",
    deleteConfirm: "确定删除项目「{name}」吗？",
    deleteTitle: "删除项目",
    cancel: "取消",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    pleaseLogin: "请先登录",
    loadFailed: "泫宗画布加载失败，请确认 manshu-ui 已启动（{entry}）",
  },
  statisticalDimension: {
    title: "统计维度",
    loading: "数据加载中",
    search: "搜索",
    clear: "清除",
    apply: "应用",
    exportTable: "导出表格",
    exporting: "导出中...",
    exportSuccess: "表格已导出",
    exportFailed: "导出失败",
    exportFailedRetry: "导出失败，请稍后重试",
    exportFallback: "导出",
    unknown: "未知",
    none: "暂无",
    noData: "暂无数据",
    pageInfo: "第 {page} / {total} 页",
    tipAria: "{label}说明",
    serverError: "服务器内部错误，请稍后重试",
    searchLabel: "搜索：",
    filterLabel: "筛选：",
    projectLabel: "项目：",
    operatorLabel: "操作人：",
    points: "积分",
    pointsSpace: " 积分",
    pointsPerSec: "积分/s",
    pointsPerSecValue: "{value} 积分/s",
    pointsPerImage: "积分/张",
    times: "次",
    pieces: "个",
    images: "张",
    people: "{count} 人",
    projectsCount: "{count} 个项目",
    segmentsCount: "{count} 个片段",
    timesPoints: "{count}次 / {points}积分",
    imageVideoCount: "{image}图 {video}视频",
    countUnit: "{n}个",
    wan: "{n}万",
    duration: {
      seconds: "{n}秒",
      minutesSeconds: "{m}分{s}秒",
      minutesOnly: "{m}分钟",
    },
    tabs: {
      overview: "概览",
      project: "工作流项目",
      segment: "漫剧片段",
      canvas: "(泫宗)画布",
      member: "成员明细",
    },
    time: {
      range: "时间范围",
      current: "当前：",
      compare: "对比：",
      startDate: "开始日期",
      endDate: "结束日期",
      selectStartDate: "选择开始日期",
      selectEndDate: "选择结束日期",
      custom: "自定义",
      month: "本月",
      lastMonth: "上月",
      all: "全部时间",
      compareLastMonth: "上月",
      compareBeforeLastMonth: "上上月",
      previousPeriod: "上个周期",
      startAfterEnd: "开始日期不能大于结束日期",
      yearMonth: "{year}年{month}月",
      yearMonthFormat: "yyyy年M月",
    },
    filter: {
      canvasSearchAria: "搜索画布名称或创建者",
      canvasSearchPlaceholder: "输入画布名称或创建者...",
      projectSearchAria: "搜索项目名称",
      projectSearchPlaceholder: "输入项目名称搜索...",
      projectFilterAria: "筛选片段所属项目",
      projectFilterPlaceholder: "输入项目名称...",
      operatorFilterAria: "筛选片段操作人",
      operatorFilterPlaceholder: "输入操作人...",
      memberFilterAria: "筛选成员或项目",
      memberFilterPlaceholder: "输入成员/项目名称...",
      memberProjectSearchAria: "搜索成员项目",
      canvasProjectSearchAria: "搜索画布项目",
      searchProjectPlaceholder: "搜索项目...",
      clearProjectFilter: "清除项目筛选",
    },
    overview: {
      totalConsumption: "总积分消耗（漫剧 + 画布）",
      dramaProject: "漫剧项目",
      canvasProject: "画布项目",
      consumptionTrend: "积分消耗趋势",
      pointsConsumption: "积分消耗",
      projectCount: "项目数",
      imageWasteRate: "图片废弃率",
      videoWasteRate: "视频废弃率",
      generateCount: "生成次数",
    },
    stats: {
      totalPoints: "总积分消耗",
      totalDuration: "总项目时长",
      totalImages: "总项目图片",
      avgPerSegment: "均每片段积分",
      videoPerSec: "视频每秒消耗",
      imagePerPiece: "图片每张消耗",
      tipDuration: "实际使用视频的有效时长",
      tipAvgSegment: "片段总消耗积分 ÷ 片段数",
      tipVideoPerSec: "实际消耗积分 ÷ 有效时长",
      tipImagePerPiece: "实际消耗积分 ÷ 有效数量",
      comparedTo: "较{period}",
    },
    operation: {
      video: "视频生成",
      image: "图片生成",
      script: "剧本解析",
    },
    asset: {
      character: "人物",
      scene: "场景",
      prop: "道具",
      unit: "个",
    },
    detail: {
      pointsTypeDistribution: "积分类型分布",
      videoStats: "视频统计",
      imageStats: "图片统计",
      collaboration: "协作明细",
      costPoints: "消耗积分",
      segmentDuration: "片段时长",
      budget: "预算",
      diff: "差异",
      remainingPrefix: "剩余 ",
      overspendPrefix: "超支 ",
      remaining: "剩余 {value}",
      overspend: "超支 {value}",
      avgPerSec: "均每秒消耗",
      operator: "操作人",
      effectiveDuration: "有效时长",
      actualGenerate: "实际生成",
      wasteRate: "废弃率",
      effectiveCount: "有效数量",
      effective: "有效",
      actual: "实际",
      cost: "消耗",
      video: "视频",
      image: "图片",
      text: "文",
      total: "合计",
      costPointsValue: "{value} 积分",
      imagesValue: "{value} 张",
    },
    project: {
      backToList: "‹ 返回项目列表",
      ranking: "漫剧项目排行",
      consumptionTrend: "积分消耗趋势",
      dataDistribution: "数据分布",
      operationDistribution: "操作类型分布",
      assetDistribution: "资产分布",
      totalConsumption: "总消耗",
      totalAssets: "资产总数",
      emptyTitle: "暂无匹配项目",
      emptyDesc: "调整搜索条件后重试",
      emptyCollaborators: "暂无协作明细",
      tipImageCount: "实际使用的有效图片数量",
      tipVideoDuration:
        "视频时长代表生成视频中被使用的有效时长，所有视频字段统一",
      columns: {
        name: "项目名称",
        scriptNum: "集数",
        scriptDuration: "每集时长",
        segments: "片段数",
        members: "成员数",
        duration: "视频时长",
        imageCount: "图片数",
        total: "消耗积分",
        budget: "预算",
        diff: "差异",
        progress: "进度",
      },
    },
    segment: {
      title: "漫剧片段",
      backToList: "‹ 返回片段列表",
      emptyTitle: "暂无匹配片段",
      emptyDesc: "调整筛选条件后重试",
      ofTotal: "占总消耗 {percent}%",
      missingScriptId: "当前片段缺少 scriptId，无法查询详情",
      detailFailed: "片段详情获取失败，请稍后重试",
      columns: {
        name: "片段名称",
        project: "所属项目",
        scriptDuration: "本集时长",
        duration: "片段时长",
        cost: "消耗积分",
        perSecond: "每秒消耗",
        operator: "操作人",
      },
    },
    canvas: {
      listTitle: "画布项目列表",
      emptyTitle: "暂无画布项目",
      emptyDesc: "调整搜索条件后重试",
      columns: {
        name: "画布名称",
        creator: "创建者",
        imageGenerate: "图片生成",
        videoGenerate: "视频生成",
        lastOperateTime: "最近操作",
      },
    },
    member: {
      title: "成员明细管理",
      emptyTitle: "暂无匹配成员",
      emptyDesc: "调整搜索条件后重试",
      backToList: "‹ 返回成员列表",
      participateSummary: "参与 {projects} 个项目 · 完成 {segments} 个片段",
      projectConsumption: "各项目消耗",
      dramaProject: "漫剧项目",
      canvasProject: "画布项目",
      costAllProjects: "消耗积分(所有参与项目)",
      avgPerSec: "均/每秒消耗",
      costPerImage: "图片每张消耗",
      efficiency: "效率评级",
      efficiencyNormal: "正常",
      operationRatio: "操作类型占比",
      dramaProjects: "各漫剧项目",
      canvasProjects: "各画布项目",
      noMatchProject: "暂无匹配项目",
      noProject: "暂无项目",
      dailyTrend: "每日消耗趋势 — {project} · {period}",
      generateTrend: "生成消耗趋势 — {project} · {period}",
      segmentTitle: "漫剧片段 — {project}",
      generateDetail: "生成明细",
      imageGen: "图片生成",
      videoGen: "视频生成",
      columns: {
        name: "成员",
        projects: "所属项目",
        used: "已消耗",
        remaining: "剩余积分",
        allocated: "分配积分",
        progress: "进度",
        segment: "片段",
        script: "剧本解析",
        image: "图片生成",
        imageCount: "图片数",
        video: "视频生成",
        videoDuration: "视频时长",
        total: "合计",
        canvasName: "画布名称",
        creator: "创建者",
      },
    },
    export: {
      projectFile: "漫剧项目_{label}.xlsx",
      segmentFile: "漫剧片段_{label}.xlsx",
      canvasFile: "画布项目_{label}.xlsx",
      memberFile: "成员明细.csv",
    },
  },
};
